export type Json = string | number | boolean | null | { [key: string]: Json | undefined } | Json[];

export type Database = {
  analytics: {
    Tables: {
      bi__contributor_open_tasks: {
        Row: {
          open_tasks_by_permission: Json | null;
          syllabus_id: number | null;
          total_open_tasks: number | null;
          user_id: string | null;
        };
        Insert: {
          open_tasks_by_permission?: Json | null;
          syllabus_id?: number | null;
          total_open_tasks?: number | null;
          user_id?: string | null;
        };
        Update: {
          open_tasks_by_permission?: Json | null;
          syllabus_id?: number | null;
          total_open_tasks?: number | null;
          user_id?: string | null;
        };
        Relationships: [];
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      bi__contributor_open_tasks: {
        Args: never;
        Returns: {
          open_tasks_by_permission: Json;
          syllabus_id: number;
          total_open_tasks: number;
          user_id: string;
        }[];
      };
    };
    Enums: {
      [_ in never]: never;
    };
    CompositeTypes: {
      [_ in never]: never;
    };
  };
  billing: {
    Tables: {
      payout_accounts: {
        Row: {
          created_at: string;
          recipient_currency: string;
          recipient_email: string;
          recipient_name: string;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          recipient_currency: string;
          recipient_email: string;
          recipient_name: string;
          sys_period?: unknown;
          updated_at?: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          recipient_currency?: string;
          recipient_email?: string;
          recipient_name?: string;
          sys_period?: unknown;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      payout_accounts_history: {
        Row: {
          created_at: string;
          history_id: string;
          recipient_currency: string;
          recipient_email: string;
          recipient_name: string;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          created_at: string;
          history_id?: string;
          recipient_currency: string;
          recipient_email: string;
          recipient_name: string;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          history_id?: string;
          recipient_currency?: string;
          recipient_email?: string;
          recipient_name?: string;
          sys_period?: unknown;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      payout_rates: {
        Row: {
          created_at: string;
          created_by: string | null;
          id: string;
          rate: number;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
          valid_from: string | null;
          valid_to: string | null;
        };
        Insert: {
          created_at?: string;
          created_by?: string | null;
          id?: string;
          rate: number;
          sys_period?: unknown;
          updated_at?: string;
          user_id: string;
          valid_from?: string | null;
          valid_to?: string | null;
        };
        Update: {
          created_at?: string;
          created_by?: string | null;
          id?: string;
          rate?: number;
          sys_period?: unknown;
          updated_at?: string;
          user_id?: string;
          valid_from?: string | null;
          valid_to?: string | null;
        };
        Relationships: [];
      };
      payout_rates_history: {
        Row: {
          created_at: string;
          created_by: string | null;
          history_id: string;
          id: string | null;
          rate: number;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
          valid_from: string | null;
          valid_to: string | null;
        };
        Insert: {
          created_at: string;
          created_by?: string | null;
          history_id?: string;
          id?: string | null;
          rate: number;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
          valid_from?: string | null;
          valid_to?: string | null;
        };
        Update: {
          created_at?: string;
          created_by?: string | null;
          history_id?: string;
          id?: string | null;
          rate?: number;
          sys_period?: unknown;
          updated_at?: string;
          user_id?: string;
          valid_from?: string | null;
          valid_to?: string | null;
        };
        Relationships: [];
      };
      payout_requests: {
        Row: {
          attachments: Json | null;
          created_at: string;
          deleted_at: string | null;
          deleted_by: string | null;
          extra_bonus_in_eur: number | null;
          extra_bonus_reason: string | null;
          final_payout_in_eur: number | null;
          hours: Json;
          id: string;
          payout_rate_id: string | null;
          performance_bonus_in_eur: number | null;
          period: string;
          status: Database['billing']['Enums']['payout_request_status'];
          status_reason: string | null;
          sys_period: unknown;
          target_account_id: number | null;
          transaction_id: string | null;
          transfer_id: number | null;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          attachments?: Json | null;
          created_at?: string;
          deleted_at?: string | null;
          deleted_by?: string | null;
          extra_bonus_in_eur?: number | null;
          extra_bonus_reason?: string | null;
          final_payout_in_eur?: number | null;
          hours: Json;
          id?: string;
          payout_rate_id?: string | null;
          performance_bonus_in_eur?: number | null;
          period: string;
          status?: Database['billing']['Enums']['payout_request_status'];
          status_reason?: string | null;
          sys_period?: unknown;
          target_account_id?: number | null;
          transaction_id?: string | null;
          transfer_id?: number | null;
          updated_at?: string;
          user_id: string;
        };
        Update: {
          attachments?: Json | null;
          created_at?: string;
          deleted_at?: string | null;
          deleted_by?: string | null;
          extra_bonus_in_eur?: number | null;
          extra_bonus_reason?: string | null;
          final_payout_in_eur?: number | null;
          hours?: Json;
          id?: string;
          payout_rate_id?: string | null;
          performance_bonus_in_eur?: number | null;
          period?: string;
          status?: Database['billing']['Enums']['payout_request_status'];
          status_reason?: string | null;
          sys_period?: unknown;
          target_account_id?: number | null;
          transaction_id?: string | null;
          transfer_id?: number | null;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'payout_requests_payout_rate_id_fkey';
            columns: ['payout_rate_id'];
            isOneToOne: false;
            referencedRelation: 'payout_rates';
            referencedColumns: ['id'];
          },
        ];
      };
      payout_requests_history: {
        Row: {
          attachments: Json | null;
          created_at: string;
          deleted_at: string | null;
          deleted_by: string | null;
          extra_bonus_in_eur: number | null;
          extra_bonus_reason: string | null;
          final_payout_in_eur: number | null;
          history_id: string;
          hours: Json;
          id: string;
          payout_rate_id: string | null;
          performance_bonus_in_eur: number | null;
          period: string;
          status: Database['billing']['Enums']['payout_request_status'];
          status_reason: string | null;
          sys_period: unknown;
          target_account_id: number | null;
          transaction_id: string | null;
          transfer_id: number | null;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          attachments?: Json | null;
          created_at: string;
          deleted_at?: string | null;
          deleted_by?: string | null;
          extra_bonus_in_eur?: number | null;
          extra_bonus_reason?: string | null;
          final_payout_in_eur?: number | null;
          history_id?: string;
          hours: Json;
          id: string;
          payout_rate_id?: string | null;
          performance_bonus_in_eur?: number | null;
          period: string;
          status: Database['billing']['Enums']['payout_request_status'];
          status_reason?: string | null;
          sys_period: unknown;
          target_account_id?: number | null;
          transaction_id?: string | null;
          transfer_id?: number | null;
          updated_at: string;
          user_id: string;
        };
        Update: {
          attachments?: Json | null;
          created_at?: string;
          deleted_at?: string | null;
          deleted_by?: string | null;
          extra_bonus_in_eur?: number | null;
          extra_bonus_reason?: string | null;
          final_payout_in_eur?: number | null;
          history_id?: string;
          hours?: Json;
          id?: string;
          payout_rate_id?: string | null;
          performance_bonus_in_eur?: number | null;
          period?: string;
          status?: Database['billing']['Enums']['payout_request_status'];
          status_reason?: string | null;
          sys_period?: unknown;
          target_account_id?: number | null;
          transaction_id?: string | null;
          transfer_id?: number | null;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      user_referral_rewards: {
        Row: {
          id: string;
          metadata: Json | null;
          referral_id: string;
          rewarded_at: string | null;
          rewarded_user_id: string;
        };
        Insert: {
          id?: string;
          metadata?: Json | null;
          referral_id: string;
          rewarded_at?: string | null;
          rewarded_user_id: string;
        };
        Update: {
          id?: string;
          metadata?: Json | null;
          referral_id?: string;
          rewarded_at?: string | null;
          rewarded_user_id?: string;
        };
        Relationships: [];
      };
      user_referrals: {
        Row: {
          id: string;
          referred_at: string;
          referred_user_id: string;
          referrer_id: string;
        };
        Insert: {
          id?: string;
          referred_at?: string;
          referred_user_id: string;
          referrer_id: string;
        };
        Update: {
          id?: string;
          referred_at?: string;
          referred_user_id?: string;
          referrer_id?: string;
        };
        Relationships: [];
      };
      user_subscriptions: {
        Row: {
          created_at: string;
          customer_id: string;
          end_date: string | null;
          interval: Database['public']['Enums']['subscription_recurrence_interval'];
          interval_count: number;
          start_date: string | null;
          subscription_id: string | null;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          customer_id: string;
          end_date?: string | null;
          interval?: Database['public']['Enums']['subscription_recurrence_interval'];
          interval_count?: number;
          start_date?: string | null;
          subscription_id?: string | null;
          sys_period?: unknown;
          updated_at?: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          customer_id?: string;
          end_date?: string | null;
          interval?: Database['public']['Enums']['subscription_recurrence_interval'];
          interval_count?: number;
          start_date?: string | null;
          subscription_id?: string | null;
          sys_period?: unknown;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      user_subscriptions_history: {
        Row: {
          created_at: string;
          customer_id: string;
          end_date: string | null;
          history_id: string;
          interval: Database['public']['Enums']['subscription_recurrence_interval'];
          interval_count: number;
          start_date: string | null;
          subscription_id: string | null;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          created_at: string;
          customer_id: string;
          end_date?: string | null;
          history_id?: string;
          interval?: Database['public']['Enums']['subscription_recurrence_interval'];
          interval_count?: number;
          start_date?: string | null;
          subscription_id?: string | null;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          customer_id?: string;
          end_date?: string | null;
          history_id?: string;
          interval?: Database['public']['Enums']['subscription_recurrence_interval'];
          interval_count?: number;
          start_date?: string | null;
          subscription_id?: string | null;
          sys_period?: unknown;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      calculate_final_payout: {
        Args: {
          extra_bonus: number;
          hours_data: Json;
          performance_bonus: number;
          period_param: string;
          user_id_param: string;
        };
        Returns: Record<string, unknown>;
      };
      is_valid_hours: { Args: { hours_data: Json }; Returns: boolean };
      is_valid_period: { Args: { period_text: string }; Returns: boolean };
    };
    Enums: {
      payout_request_status:
        | 'DRAFT'
        | 'WAITING_FOR_APPROVAL'
        | 'REJECTED'
        | 'APPROVED'
        | 'PAYMENT_WAITING_FOR_APPROVAL'
        | 'PAYMENT_IN_PROGRESS'
        | 'PAYMENT_SUCCEEDED'
        | 'PAYMENT_FAILED';
    };
    CompositeTypes: {
      [_ in never]: never;
    };
  };
  categories: {
    Tables: {
      courses: {
        Row: {
          course_level: string | null;
          created_at: string | null;
          formular_booklet: string;
          full_name: string;
          icon: string | null;
          id: string;
          short_name: string;
          slug: string;
          syllabus_id: number;
          updated_at: string | null;
        };
        Insert: {
          course_level?: string | null;
          created_at?: string | null;
          formular_booklet?: string;
          full_name: string;
          icon?: string | null;
          id?: string;
          short_name: string;
          slug: string;
          syllabus_id: number;
          updated_at?: string | null;
        };
        Update: {
          course_level?: string | null;
          created_at?: string | null;
          formular_booklet?: string;
          full_name?: string;
          icon?: string | null;
          id?: string;
          short_name?: string;
          slug?: string;
          syllabus_id?: number;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'courses_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'courses_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_courses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'courses_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_programs';
            referencedColumns: ['id'];
          },
        ];
      };
      difficulty_boundaries: {
        Row: {
          course_level: string;
          created_at: string | null;
          difficulty_display_name: string | null;
          lower_bound_marks: number;
          syllabus_id: number;
          updated_at: string | null;
        };
        Insert: {
          course_level: string;
          created_at?: string | null;
          difficulty_display_name?: string | null;
          lower_bound_marks: number;
          syllabus_id: number;
          updated_at?: string | null;
        };
        Update: {
          course_level?: string;
          created_at?: string | null;
          difficulty_display_name?: string | null;
          lower_bound_marks?: number;
          syllabus_id?: number;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'difficulty_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'difficulty_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_courses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'difficulty_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_programs';
            referencedColumns: ['id'];
          },
        ];
      };
      grade_boundaries: {
        Row: {
          course_level: string;
          created_at: string | null;
          grade: number;
          grade_display_name: string | null;
          lower_bound_percentage: number;
          syllabus_id: number;
          updated_at: string | null;
        };
        Insert: {
          course_level: string;
          created_at?: string | null;
          grade: number;
          grade_display_name?: string | null;
          lower_bound_percentage: number;
          syllabus_id: number;
          updated_at?: string | null;
        };
        Update: {
          course_level?: string;
          created_at?: string | null;
          grade?: number;
          grade_display_name?: string | null;
          lower_bound_percentage?: number;
          syllabus_id?: number;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'grade_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'grade_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_courses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'grade_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_programs';
            referencedColumns: ['id'];
          },
        ];
      };
      pace_boundaries: {
        Row: {
          bucket_comment: string | null;
          bucket_name: string | null;
          bucket_num: number;
          course_level: string;
          created_at: string | null;
          lower_bound_seconds: number;
          pace_boundary_type: Database['categories']['Enums']['pace_boundary_types'];
          syllabus_id: number;
          updated_at: string | null;
        };
        Insert: {
          bucket_comment?: string | null;
          bucket_name?: string | null;
          bucket_num: number;
          course_level: string;
          created_at?: string | null;
          lower_bound_seconds: number;
          pace_boundary_type: Database['categories']['Enums']['pace_boundary_types'];
          syllabus_id: number;
          updated_at?: string | null;
        };
        Update: {
          bucket_comment?: string | null;
          bucket_name?: string | null;
          bucket_num?: number;
          course_level?: string;
          created_at?: string | null;
          lower_bound_seconds?: number;
          pace_boundary_type?: Database['categories']['Enums']['pace_boundary_types'];
          syllabus_id?: number;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'pace_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'pace_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_courses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'pace_boundaries_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_programs';
            referencedColumns: ['id'];
          },
        ];
      };
      programs: {
        Row: {
          code: Database['categories']['Enums']['program'];
          created_at: string | null;
          full_name: string;
          icon: string | null;
          short_name: string;
          updated_at: string | null;
        };
        Insert: {
          code: Database['categories']['Enums']['program'];
          created_at?: string | null;
          full_name: string;
          icon?: string | null;
          short_name: string;
          updated_at?: string | null;
        };
        Update: {
          code?: Database['categories']['Enums']['program'];
          created_at?: string | null;
          full_name?: string;
          icon?: string | null;
          short_name?: string;
          updated_at?: string | null;
        };
        Relationships: [];
      };
      syllabus_user_subscriptions: {
        Row: {
          course_level: string | null;
          created_at: string;
          exam_date_id: number | null;
          id: string;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
          use_new_questions: boolean;
          user_id: string;
        };
        Insert: {
          course_level?: string | null;
          created_at?: string;
          exam_date_id?: number | null;
          id?: string;
          syllabus_id: number;
          sys_period?: unknown;
          updated_at?: string;
          use_new_questions?: boolean;
          user_id: string;
        };
        Update: {
          course_level?: string | null;
          created_at?: string;
          exam_date_id?: number | null;
          id?: string;
          syllabus_id?: number;
          sys_period?: unknown;
          updated_at?: string;
          use_new_questions?: boolean;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'syllabus_user_subscriptions_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'syllabus_user_subscriptions_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_courses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'syllabus_user_subscriptions_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_programs';
            referencedColumns: ['id'];
          },
        ];
      };
      syllabus_user_subscriptions_history: {
        Row: {
          course_level: string | null;
          created_at: string;
          exam_date_id: number | null;
          history_id: string;
          id: string;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
          use_new_questions: boolean | null;
          user_id: string;
        };
        Insert: {
          course_level?: string | null;
          created_at: string;
          exam_date_id?: number | null;
          history_id?: string;
          id: string;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
          use_new_questions?: boolean | null;
          user_id: string;
        };
        Update: {
          course_level?: string | null;
          created_at?: string;
          exam_date_id?: number | null;
          history_id?: string;
          id?: string;
          syllabus_id?: number;
          sys_period?: unknown;
          updated_at?: string;
          use_new_questions?: boolean | null;
          user_id?: string;
        };
        Relationships: [];
      };
      syllabuses: {
        Row: {
          active: boolean;
          assessment_modes: Database['categories']['Enums']['assessment_modes'][];
          available_courses: string[] | null;
          created_at: string | null;
          description: string | null;
          id: number;
          mark_calculation_method: Database['categories']['Enums']['mark_calculation_method'] | null;
          name: string | null;
          program: Database['categories']['Enums']['program'];
          short_name: string | null;
          slug: string;
          subject: Database['categories']['Enums']['subject'];
          sys_period: unknown;
          updated_at: string | null;
        };
        Insert: {
          active?: boolean;
          assessment_modes?: Database['categories']['Enums']['assessment_modes'][];
          available_courses?: string[] | null;
          created_at?: string | null;
          description?: string | null;
          id?: number;
          mark_calculation_method?: Database['categories']['Enums']['mark_calculation_method'] | null;
          name?: string | null;
          program: Database['categories']['Enums']['program'];
          short_name?: string | null;
          slug: string;
          subject: Database['categories']['Enums']['subject'];
          sys_period?: unknown;
          updated_at?: string | null;
        };
        Update: {
          active?: boolean;
          assessment_modes?: Database['categories']['Enums']['assessment_modes'][];
          available_courses?: string[] | null;
          created_at?: string | null;
          description?: string | null;
          id?: number;
          mark_calculation_method?: Database['categories']['Enums']['mark_calculation_method'] | null;
          name?: string | null;
          program?: Database['categories']['Enums']['program'];
          short_name?: string | null;
          slug?: string;
          subject?: Database['categories']['Enums']['subject'];
          sys_period?: unknown;
          updated_at?: string | null;
        };
        Relationships: [];
      };
      syllabuses_history: {
        Row: {
          active: boolean;
          assessment_modes: Database['categories']['Enums']['assessment_modes'][];
          available_courses: string[] | null;
          created_at: string | null;
          description: string | null;
          history_id: string;
          id: number;
          mark_calculation_method: Database['categories']['Enums']['mark_calculation_method'] | null;
          name: string | null;
          program: Database['categories']['Enums']['program'];
          short_name: string | null;
          slug: string;
          subject: Database['categories']['Enums']['subject'];
          sys_period: unknown;
          updated_at: string | null;
        };
        Insert: {
          active: boolean;
          assessment_modes: Database['categories']['Enums']['assessment_modes'][];
          available_courses?: string[] | null;
          created_at?: string | null;
          description?: string | null;
          history_id?: string;
          id: number;
          mark_calculation_method?: Database['categories']['Enums']['mark_calculation_method'] | null;
          name?: string | null;
          program: Database['categories']['Enums']['program'];
          short_name?: string | null;
          slug: string;
          subject: Database['categories']['Enums']['subject'];
          sys_period: unknown;
          updated_at?: string | null;
        };
        Update: {
          active?: boolean;
          assessment_modes?: Database['categories']['Enums']['assessment_modes'][];
          available_courses?: string[] | null;
          created_at?: string | null;
          description?: string | null;
          history_id?: string;
          id?: number;
          mark_calculation_method?: Database['categories']['Enums']['mark_calculation_method'] | null;
          name?: string | null;
          program?: Database['categories']['Enums']['program'];
          short_name?: string | null;
          slug?: string;
          subject?: Database['categories']['Enums']['subject'];
          sys_period?: unknown;
          updated_at?: string | null;
        };
        Relationships: [];
      };
      topics_level_01: {
        Row: {
          active: boolean | null;
          color_name: string | null;
          created_at: string | null;
          description: string | null;
          id: number;
          name: string | null;
          slug: string | null;
          sort_order: number;
          syllabus_id: number;
          updated_at: string | null;
        };
        Insert: {
          active?: boolean | null;
          color_name?: string | null;
          created_at?: string | null;
          description?: string | null;
          id?: number;
          name?: string | null;
          slug?: string | null;
          sort_order: number;
          syllabus_id: number;
          updated_at?: string | null;
        };
        Update: {
          active?: boolean | null;
          color_name?: string | null;
          created_at?: string | null;
          description?: string | null;
          id?: number;
          name?: string | null;
          slug?: string | null;
          sort_order?: number;
          syllabus_id?: number;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'topics_level_01_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'topics_level_01_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_courses';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'topics_level_01_syllabus_id_fkey';
            columns: ['syllabus_id'];
            isOneToOne: false;
            referencedRelation: 'syllabuses_with_programs';
            referencedColumns: ['id'];
          },
        ];
      };
      topics_level_02: {
        Row: {
          active: boolean | null;
          code: string;
          course_level: string | null;
          course_levels: string[] | null;
          created_at: string | null;
          description: string | null;
          example: string | null;
          icon: string | null;
          id: number;
          name: string | null;
          short_name: string | null;
          slug: string | null;
          sort_order: number;
          topic_level_01_id: number;
          updated_at: string | null;
        };
        Insert: {
          active?: boolean | null;
          code: string;
          course_level?: string | null;
          course_levels?: string[] | null;
          created_at?: string | null;
          description?: string | null;
          example?: string | null;
          icon?: string | null;
          id?: number;
          name?: string | null;
          short_name?: string | null;
          slug?: string | null;
          sort_order: number;
          topic_level_01_id: number;
          updated_at?: string | null;
        };
        Update: {
          active?: boolean | null;
          code?: string;
          course_level?: string | null;
          course_levels?: string[] | null;
          created_at?: string | null;
          description?: string | null;
          example?: string | null;
          icon?: string | null;
          id?: number;
          name?: string | null;
          short_name?: string | null;
          slug?: string | null;
          sort_order?: number;
          topic_level_01_id?: number;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'topics_level_02_topic_level_01_id_fkey';
            columns: ['topic_level_01_id'];
            isOneToOne: false;
            referencedRelation: 'topics_level_01';
            referencedColumns: ['id'];
          },
        ];
      };
      topics_level_02_topics_level_03_bindings: {
        Row: {
          created_at: string | null;
          topic_level_02_id: number;
          topic_level_03_id: number;
        };
        Insert: {
          created_at?: string | null;
          topic_level_02_id: number;
          topic_level_03_id: number;
        };
        Update: {
          created_at?: string | null;
          topic_level_02_id?: number;
          topic_level_03_id?: number;
        };
        Relationships: [
          {
            foreignKeyName: 'topics_level_02_topics_level_03_bindings_topic_level_02_id_fkey';
            columns: ['topic_level_02_id'];
            isOneToOne: false;
            referencedRelation: 'topics_level_02';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'topics_level_02_topics_level_03_bindings_topic_level_03_id_fkey';
            columns: ['topic_level_03_id'];
            isOneToOne: false;
            referencedRelation: 'topics_level_03';
            referencedColumns: ['id'];
          },
        ];
      };
      topics_level_03: {
        Row: {
          code: string;
          created_at: string | null;
          id: number;
          name: string | null;
          slug: string | null;
          sort_order: number;
          testable_concepts: string | null;
          topic_level_02_id: number | null;
          updated_at: string | null;
        };
        Insert: {
          code: string;
          created_at?: string | null;
          id?: number;
          name?: string | null;
          slug?: string | null;
          sort_order: number;
          testable_concepts?: string | null;
          topic_level_02_id?: number | null;
          updated_at?: string | null;
        };
        Update: {
          code?: string;
          created_at?: string | null;
          id?: number;
          name?: string | null;
          slug?: string | null;
          sort_order?: number;
          testable_concepts?: string | null;
          topic_level_02_id?: number | null;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'topics_level_03_topic_level_02_id_fkey';
            columns: ['topic_level_02_id'];
            isOneToOne: false;
            referencedRelation: 'topics_level_02';
            referencedColumns: ['id'];
          },
        ];
      };
    };
    Views: {
      syllabuses_with_courses: {
        Row: {
          active: boolean | null;
          assessment_modes: Database['categories']['Enums']['assessment_modes'][] | null;
          available_courses: string[] | null;
          course_full_name: string | null;
          course_icon: string | null;
          course_level: string | null;
          course_short_name: string | null;
          course_slug: string | null;
          created_at: string | null;
          description: string | null;
          formular_booklet: string | null;
          id: number | null;
          mark_calculation_method: Database['categories']['Enums']['mark_calculation_method'] | null;
          name: string | null;
          program: Database['categories']['Enums']['program'] | null;
          program_full_name: string | null;
          program_icon: string | null;
          program_short_name: string | null;
          short_name: string | null;
          slug: string | null;
          subject: Database['categories']['Enums']['subject'] | null;
          updated_at: string | null;
        };
        Relationships: [];
      };
      syllabuses_with_programs: {
        Row: {
          active: boolean | null;
          assessment_modes: Database['categories']['Enums']['assessment_modes'][] | null;
          available_courses: string[] | null;
          created_at: string | null;
          description: string | null;
          id: number | null;
          mark_calculation_method: Database['categories']['Enums']['mark_calculation_method'] | null;
          name: string | null;
          program: Database['categories']['Enums']['program'] | null;
          program_full_name: string | null;
          program_icon: string | null;
          program_short_name: string | null;
          short_name: string | null;
          slug: string | null;
          subject: Database['categories']['Enums']['subject'] | null;
          updated_at: string | null;
        };
        Relationships: [];
      };
      topics_tree: {
        Row: {
          jsonb_agg: Json | null;
        };
        Relationships: [];
      };
    };
    Functions: {
      get_user_subscribed_courses: {
        Args: { program_filter: Database['categories']['Enums']['program'] };
        Returns: {
          course_level: string;
          syllabus_id: number;
        }[];
      };
    };
    Enums: {
      assessment_modes: 'CLASS_TEST' | 'MOCK_EXAM' | 'FINAL_EXAM';
      mark_calculation_method: 'ADDITIVE' | 'SELECTIVE';
      pace_boundary_types: 'practice';
      program: 'AC' | 'IBDP' | 'HSC' | 'AP' | 'CAIE_AL' | 'PE_GCSE' | 'SAT';
      subject: 'MATH';
    };
    CompositeTypes: {
      [_ in never]: never;
    };
  };
  learn_hub: {
    Tables: {
      page_versions: {
        Row: {
          content: string | null;
          created_at: string | null;
          id: number;
          language_code: Database['learn_hub']['Enums']['language_code'];
          page_status: Database['learn_hub']['Enums']['page_status'];
          page_type: Database['learn_hub']['Enums']['page_type'];
          topic_level_02_id: number | null;
          updated_at: string | null;
        };
        Insert: {
          content?: string | null;
          created_at?: string | null;
          id?: number;
          language_code?: Database['learn_hub']['Enums']['language_code'];
          page_status?: Database['learn_hub']['Enums']['page_status'];
          page_type: Database['learn_hub']['Enums']['page_type'];
          topic_level_02_id?: number | null;
          updated_at?: string | null;
        };
        Update: {
          content?: string | null;
          created_at?: string | null;
          id?: number;
          language_code?: Database['learn_hub']['Enums']['language_code'];
          page_status?: Database['learn_hub']['Enums']['page_status'];
          page_type?: Database['learn_hub']['Enums']['page_type'];
          topic_level_02_id?: number | null;
          updated_at?: string | null;
        };
        Relationships: [];
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      create_draft: {
        Args: {
          args: Database['learn_hub']['CompositeTypes']['create_draft_args'];
        };
        Returns: undefined;
      };
      publish_version: {
        Args: { args: Database['learn_hub']['CompositeTypes']['publish_args'] };
        Returns: undefined;
      };
    };
    Enums: {
      language_code: 'en';
      page_status: 'draft' | 'published' | 'archived';
      page_type: 'concept' | 'cheat_sheet' | 'insights' | 'past_papers';
    };
    CompositeTypes: {
      create_draft_args: {
        topic_level_02_id: number | null;
        page_type: Database['learn_hub']['Enums']['page_type'] | null;
        language_code: Database['learn_hub']['Enums']['language_code'] | null;
        content: string | null;
      };
      publish_args: {
        topic_level_02_id: number | null;
        page_type: Database['learn_hub']['Enums']['page_type'] | null;
        language_code: Database['learn_hub']['Enums']['language_code'] | null;
        page_version_id: number | null;
      };
    };
  };
  learning: {
    Tables: {
      activities: {
        Row: {
          challenge_activity_id: string | null;
          created_at: string;
          practice_activity_id: string | null;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          challenge_activity_id?: string | null;
          created_at?: string;
          practice_activity_id?: string | null;
          updated_at?: string;
          user_id: string;
        };
        Update: {
          challenge_activity_id?: string | null;
          created_at?: string;
          practice_activity_id?: string | null;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'activities_challenge_activity_id_fkey';
            columns: ['challenge_activity_id'];
            isOneToOne: false;
            referencedRelation: 'challenge_activities';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'activities_practice_activity_id_fkey';
            columns: ['practice_activity_id'];
            isOneToOne: false;
            referencedRelation: 'practice_activities';
            referencedColumns: ['id'];
          },
        ];
      };
      assessments: {
        Row: {
          active: boolean | null;
          assessment_type: Database['categories']['Enums']['assessment_modes'];
          course_level: string | null;
          created_at: string;
          grade_percentage: number | null;
          id: number;
          syllabus_id: number;
          sys_period: unknown;
          target_date: string;
          title: string;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          active?: boolean | null;
          assessment_type: Database['categories']['Enums']['assessment_modes'];
          course_level?: string | null;
          created_at?: string;
          grade_percentage?: number | null;
          id?: number;
          syllabus_id: number;
          sys_period?: unknown;
          target_date: string;
          title: string;
          updated_at?: string;
          user_id: string;
        };
        Update: {
          active?: boolean | null;
          assessment_type?: Database['categories']['Enums']['assessment_modes'];
          course_level?: string | null;
          created_at?: string;
          grade_percentage?: number | null;
          id?: number;
          syllabus_id?: number;
          sys_period?: unknown;
          target_date?: string;
          title?: string;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      assessments_history: {
        Row: {
          active: boolean | null;
          assessment_type: Database['categories']['Enums']['assessment_modes'];
          course_level: string | null;
          created_at: string;
          grade_percentage: number | null;
          id: number;
          syllabus_id: number;
          sys_period: unknown;
          target_date: string;
          title: string;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          active?: boolean | null;
          assessment_type: Database['categories']['Enums']['assessment_modes'];
          course_level?: string | null;
          created_at: string;
          grade_percentage?: number | null;
          id: number;
          syllabus_id: number;
          sys_period: unknown;
          target_date: string;
          title: string;
          updated_at: string;
          user_id: string;
        };
        Update: {
          active?: boolean | null;
          assessment_type?: Database['categories']['Enums']['assessment_modes'];
          course_level?: string | null;
          created_at?: string;
          grade_percentage?: number | null;
          id?: number;
          syllabus_id?: number;
          sys_period?: unknown;
          target_date?: string;
          title?: string;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      assessments_topics_level_02: {
        Row: {
          assessment_id: number;
          topic_level_02_id: number;
        };
        Insert: {
          assessment_id: number;
          topic_level_02_id: number;
        };
        Update: {
          assessment_id?: number;
          topic_level_02_id?: number;
        };
        Relationships: [
          {
            foreignKeyName: 'assessments_topics_level_02_assessment_id_fkey';
            columns: ['assessment_id'];
            isOneToOne: false;
            referencedRelation: 'assessments';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'assessments_topics_level_02_topic_level_02_id_fkey';
            columns: ['topic_level_02_id'];
            isOneToOne: false;
            referencedRelation: 'topic_level_02_weights';
            referencedColumns: ['topic_id'];
          },
          {
            foreignKeyName: 'assessments_topics_level_02_topic_level_02_id_fkey';
            columns: ['topic_level_02_id'];
            isOneToOne: false;
            referencedRelation: 'topic_level_03_weights';
            referencedColumns: ['topic_level_02_id'];
          },
        ];
      };
      assignment_section_questions: {
        Row: {
          assignment_id: string;
          assignment_section_id: string;
          created_at: string;
          position: number;
          question_id: number;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          assignment_id: string;
          assignment_section_id: string;
          created_at?: string;
          position: number;
          question_id: number;
          sys_period?: unknown;
          updated_at?: string;
        };
        Update: {
          assignment_id?: string;
          assignment_section_id?: string;
          created_at?: string;
          position?: number;
          question_id?: number;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'assignment_section_questions_assignment_id_assignment_sect_fkey';
            columns: ['assignment_id', 'assignment_section_id'];
            isOneToOne: false;
            referencedRelation: 'assignment_sections';
            referencedColumns: ['assignment_id', 'id'];
          },
        ];
      };
      assignment_section_questions_history: {
        Row: {
          assignment_id: string;
          assignment_section_id: string;
          created_at: string;
          history_id: string;
          position: number;
          question_id: number;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          assignment_id: string;
          assignment_section_id: string;
          created_at: string;
          history_id?: string;
          position: number;
          question_id: number;
          sys_period: unknown;
          updated_at: string;
        };
        Update: {
          assignment_id?: string;
          assignment_section_id?: string;
          created_at?: string;
          history_id?: string;
          position?: number;
          question_id?: number;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [];
      };
      assignment_sections: {
        Row: {
          assignment_id: string;
          break_in_minutes: number | null;
          course_level: string;
          created_at: string;
          id: string;
          name: string | null;
          position: number;
          sys_period: unknown;
          time_limit_in_minutes: number | null;
          updated_at: string;
        };
        Insert: {
          assignment_id: string;
          break_in_minutes?: number | null;
          course_level: string;
          created_at?: string;
          id?: string;
          name?: string | null;
          position: number;
          sys_period?: unknown;
          time_limit_in_minutes?: number | null;
          updated_at?: string;
        };
        Update: {
          assignment_id?: string;
          break_in_minutes?: number | null;
          course_level?: string;
          created_at?: string;
          id?: string;
          name?: string | null;
          position?: number;
          sys_period?: unknown;
          time_limit_in_minutes?: number | null;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'assignment_sections_assignment_id_fkey';
            columns: ['assignment_id'];
            isOneToOne: false;
            referencedRelation: 'assignments';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'assignment_sections_assignment_id_fkey';
            columns: ['assignment_id'];
            isOneToOne: false;
            referencedRelation: 'assignments_available';
            referencedColumns: ['id'];
          },
        ];
      };
      assignment_sections_history: {
        Row: {
          assignment_id: string;
          break_in_minutes: number | null;
          course_level: string;
          created_at: string;
          history_id: string;
          id: string;
          name: string | null;
          position: number;
          sys_period: unknown;
          time_limit_in_minutes: number | null;
          updated_at: string;
        };
        Insert: {
          assignment_id: string;
          break_in_minutes?: number | null;
          course_level: string;
          created_at: string;
          history_id?: string;
          id: string;
          name?: string | null;
          position: number;
          sys_period: unknown;
          time_limit_in_minutes?: number | null;
          updated_at: string;
        };
        Update: {
          assignment_id?: string;
          break_in_minutes?: number | null;
          course_level?: string;
          created_at?: string;
          history_id?: string;
          id?: string;
          name?: string | null;
          position?: number;
          sys_period?: unknown;
          time_limit_in_minutes?: number | null;
          updated_at?: string;
        };
        Relationships: [];
      };
      assignments: {
        Row: {
          created_at: string;
          id: string;
          is_original: boolean;
          name: string | null;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          id?: string;
          is_original: boolean;
          name?: string | null;
          syllabus_id: number;
          sys_period?: unknown;
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          id?: string;
          is_original?: boolean;
          name?: string | null;
          syllabus_id?: number;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [];
      };
      assignments_history: {
        Row: {
          created_at: string;
          history_id: string;
          id: string;
          is_original: boolean;
          name: string | null;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          created_at: string;
          history_id?: string;
          id: string;
          is_original: boolean;
          name?: string | null;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
        };
        Update: {
          created_at?: string;
          history_id?: string;
          id?: string;
          is_original?: boolean;
          name?: string | null;
          syllabus_id?: number;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [];
      };
      challenge_activities: {
        Row: {
          assignment_section_id: string;
          created_at: string;
          current_question_id: number | null;
          id: string;
          status: Database['learning']['Enums']['challenge_activity_status'];
          updated_at: string;
          user_id: string;
        };
        Insert: {
          assignment_section_id: string;
          created_at?: string;
          current_question_id?: number | null;
          id?: string;
          status?: Database['learning']['Enums']['challenge_activity_status'];
          updated_at?: string;
          user_id: string;
        };
        Update: {
          assignment_section_id?: string;
          created_at?: string;
          current_question_id?: number | null;
          id?: string;
          status?: Database['learning']['Enums']['challenge_activity_status'];
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'challenge_activities_assignment_section_id_fkey';
            columns: ['assignment_section_id'];
            isOneToOne: false;
            referencedRelation: 'assignment_sections';
            referencedColumns: ['id'];
          },
        ];
      };
      challenge_activity_question_attempts: {
        Row: {
          challenge_activity_id: string;
          created_at: string | null;
          question_attempt_id: string;
          question_id: number;
          status: Database['learning']['Enums']['challenge_activity_question_attempt_status'];
        };
        Insert: {
          challenge_activity_id: string;
          created_at?: string | null;
          question_attempt_id: string;
          question_id: number;
          status?: Database['learning']['Enums']['challenge_activity_question_attempt_status'];
        };
        Update: {
          challenge_activity_id?: string;
          created_at?: string | null;
          question_attempt_id?: string;
          question_id?: number;
          status?: Database['learning']['Enums']['challenge_activity_question_attempt_status'];
        };
        Relationships: [];
      };
      challenge_activity_statuses: {
        Row: {
          challenge_activity_id: string;
          created_at: string;
          id: string;
          status: Database['learning']['Enums']['challenge_activity_status'];
        };
        Insert: {
          challenge_activity_id: string;
          created_at?: string;
          id?: string;
          status: Database['learning']['Enums']['challenge_activity_status'];
        };
        Update: {
          challenge_activity_id?: string;
          created_at?: string;
          id?: string;
          status?: Database['learning']['Enums']['challenge_activity_status'];
        };
        Relationships: [
          {
            foreignKeyName: 'challenge_activity_statuses_challenge_activity_id_fkey';
            columns: ['challenge_activity_id'];
            isOneToOne: false;
            referencedRelation: 'challenge_activities';
            referencedColumns: ['id'];
          },
        ];
      };
      practice_activities: {
        Row: {
          created_at: string;
          id: string;
          metadata: Json | null;
          question_attempt_id: string | null;
          selected_candidate_id: string | null;
          status: Database['learning']['Enums']['practice_activity_status'];
          updated_at: string;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          id?: string;
          metadata?: Json | null;
          question_attempt_id?: string | null;
          selected_candidate_id?: string | null;
          status?: Database['learning']['Enums']['practice_activity_status'];
          updated_at?: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          id?: string;
          metadata?: Json | null;
          question_attempt_id?: string | null;
          selected_candidate_id?: string | null;
          status?: Database['learning']['Enums']['practice_activity_status'];
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'practice_activities_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'practice_activities_selected_candidate_id_fkey';
            columns: ['selected_candidate_id'];
            isOneToOne: false;
            referencedRelation: 'practice_activity_candidates';
            referencedColumns: ['id'];
          },
        ];
      };
      practice_activity_candidate_questions: {
        Row: {
          candidate_id: string;
          created_at: string;
          id: string;
          question_id: number;
          sort_order: number;
        };
        Insert: {
          candidate_id: string;
          created_at?: string;
          id?: string;
          question_id: number;
          sort_order?: number;
        };
        Update: {
          candidate_id?: string;
          created_at?: string;
          id?: string;
          question_id?: number;
          sort_order?: number;
        };
        Relationships: [
          {
            foreignKeyName: 'practice_activity_candidate_questions_candidate_id_fkey';
            columns: ['candidate_id'];
            isOneToOne: false;
            referencedRelation: 'practice_activity_candidates';
            referencedColumns: ['id'];
          },
        ];
      };
      practice_activity_candidates: {
        Row: {
          created_at: string;
          id: string;
          metadata: Json | null;
          practice_activity_id: string;
          question_id: number | null;
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          id?: string;
          metadata?: Json | null;
          practice_activity_id: string;
          question_id?: number | null;
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          id?: string;
          metadata?: Json | null;
          practice_activity_id?: string;
          question_id?: number | null;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'practice_activity_candidates_practice_activity_id_fkey';
            columns: ['practice_activity_id'];
            isOneToOne: false;
            referencedRelation: 'practice_activities';
            referencedColumns: ['id'];
          },
        ];
      };
      practice_activity_question_attempts: {
        Row: {
          created_at: string;
          practice_activity_id: string;
          question_attempt_id: string;
        };
        Insert: {
          created_at?: string;
          practice_activity_id: string;
          question_attempt_id: string;
        };
        Update: {
          created_at?: string;
          practice_activity_id?: string;
          question_attempt_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'practice_activity_question_attempts_practice_activity_id_fkey';
            columns: ['practice_activity_id'];
            isOneToOne: false;
            referencedRelation: 'practice_activities';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'practice_activity_question_attempts_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
        ];
      };
      practice_activity_statuses: {
        Row: {
          created_at: string;
          id: string;
          practice_activity_id: string;
          status: Database['learning']['Enums']['practice_activity_status'];
        };
        Insert: {
          created_at?: string;
          id?: string;
          practice_activity_id: string;
          status: Database['learning']['Enums']['practice_activity_status'];
        };
        Update: {
          created_at?: string;
          id?: string;
          practice_activity_id?: string;
          status?: Database['learning']['Enums']['practice_activity_status'];
        };
        Relationships: [
          {
            foreignKeyName: 'practice_activity_statuses_practice_activity_id_fkey';
            columns: ['practice_activity_id'];
            isOneToOne: false;
            referencedRelation: 'practice_activities';
            referencedColumns: ['id'];
          },
        ];
      };
      question_attempt_chats: {
        Row: {
          created_at: string;
          post_grading_llm_chat_id: number | null;
          pre_grading_llm_chat_id: number | null;
          question_attempt_id: string;
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          post_grading_llm_chat_id?: number | null;
          pre_grading_llm_chat_id?: number | null;
          question_attempt_id: string;
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          post_grading_llm_chat_id?: number | null;
          pre_grading_llm_chat_id?: number | null;
          question_attempt_id?: string;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'question_attempt_chats_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: true;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
        ];
      };
      question_attempt_grading_feedbacks: {
        Row: {
          author: string;
          created_at: string;
          id: string;
          score: number;
          text_feedback: string;
          updated_at: string;
        };
        Insert: {
          author: string;
          created_at?: string;
          id: string;
          score: number;
          text_feedback: string;
          updated_at?: string;
        };
        Update: {
          author?: string;
          created_at?: string;
          id?: string;
          score?: number;
          text_feedback?: string;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'question_attempt_grading_feedbacks_id_fkey';
            columns: ['id'];
            isOneToOne: true;
            referencedRelation: 'question_attempt_gradings';
            referencedColumns: ['id'];
          },
        ];
      };
      question_attempt_gradings: {
        Row: {
          created_at: string;
          grading_result: Json;
          id: string;
          question_attempt_id: string;
          self_grading: boolean | null;
          stems: number[] | null;
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          grading_result: Json;
          id?: string;
          question_attempt_id: string;
          self_grading?: boolean | null;
          stems?: number[] | null;
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          grading_result?: Json;
          id?: string;
          question_attempt_id?: string;
          self_grading?: boolean | null;
          stems?: number[] | null;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'question_attempt_gradings_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
        ];
      };
      question_attempt_mcq_responses: {
        Row: {
          created_at: string;
          id: string;
          question_attempt_grading_id: string | null;
          question_attempt_id: string;
          selected_option_indexes: number[];
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          id?: string;
          question_attempt_grading_id?: string | null;
          question_attempt_id: string;
          selected_option_indexes: number[];
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          id?: string;
          question_attempt_grading_id?: string | null;
          question_attempt_id?: string;
          selected_option_indexes?: number[];
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'multiple_choice_question_attem_question_attempt_grading_id_fkey';
            columns: ['question_attempt_grading_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempt_gradings';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'multiple_choice_question_attempt_respo_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: true;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
        ];
      };
      question_attempt_response_images: {
        Row: {
          bucket_name: string | null;
          created_at: string;
          id: string;
          image_name: string | null;
          order: number;
          question_attempt_grading_id: string | null;
          question_attempt_id: string;
          updated_at: string;
        };
        Insert: {
          bucket_name?: string | null;
          created_at?: string;
          id?: string;
          image_name?: string | null;
          order?: number;
          question_attempt_grading_id?: string | null;
          question_attempt_id: string;
          updated_at?: string;
        };
        Update: {
          bucket_name?: string | null;
          created_at?: string;
          id?: string;
          image_name?: string | null;
          order?: number;
          question_attempt_grading_id?: string | null;
          question_attempt_id?: string;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'question_attempt_response_imag_question_attempt_grading_id_fkey';
            columns: ['question_attempt_grading_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempt_gradings';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'question_attempt_response_images_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
        ];
      };
      question_attempt_statuses: {
        Row: {
          created_at: string;
          id: string;
          question_attempt_id: string;
          status: Database['learning']['Enums']['question_attempt_status'];
        };
        Insert: {
          created_at?: string;
          id?: string;
          question_attempt_id: string;
          status: Database['learning']['Enums']['question_attempt_status'];
        };
        Update: {
          created_at?: string;
          id?: string;
          question_attempt_id?: string;
          status?: Database['learning']['Enums']['question_attempt_status'];
        };
        Relationships: [
          {
            foreignKeyName: 'question_attempt_statuses_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
        ];
      };
      question_attempt_votes: {
        Row: {
          created_at: string;
          id: number;
          obsolete: boolean | null;
          problems: Json | null;
          question_attempt_id: string | null;
          question_id: number;
          text_feedback: string | null;
          user_id: string;
          vote: boolean;
        };
        Insert: {
          created_at?: string;
          id?: number;
          obsolete?: boolean | null;
          problems?: Json | null;
          question_attempt_id?: string | null;
          question_id: number;
          text_feedback?: string | null;
          user_id: string;
          vote: boolean;
        };
        Update: {
          created_at?: string;
          id?: number;
          obsolete?: boolean | null;
          problems?: Json | null;
          question_attempt_id?: string | null;
          question_id?: number;
          text_feedback?: string | null;
          user_id?: string;
          vote?: boolean;
        };
        Relationships: [
          {
            foreignKeyName: 'question_attempt_votes_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
        ];
      };
      question_attempts: {
        Row: {
          created_at: string;
          grading_result: Json | null;
          id: string;
          question_id: number;
          status: Database['learning']['Enums']['question_attempt_status'];
          updated_at: string;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          grading_result?: Json | null;
          id?: string;
          question_id: number;
          status?: Database['learning']['Enums']['question_attempt_status'];
          updated_at?: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          grading_result?: Json | null;
          id?: string;
          question_id?: number;
          status?: Database['learning']['Enums']['question_attempt_status'];
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      topic_level_02_proficiencies: {
        Row: {
          created_at: string;
          id: string;
          lower: number;
          mean: number;
          question_attempt_id: string | null;
          standard_deviation: number;
          topic_id: number;
          upper: number;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          id?: string;
          lower: number;
          mean: number;
          question_attempt_id?: string | null;
          standard_deviation: number;
          topic_id: number;
          upper: number;
          user_id: string;
        };
        Update: {
          created_at?: string;
          id?: string;
          lower?: number;
          mean?: number;
          question_attempt_id?: string | null;
          standard_deviation?: number;
          topic_id?: number;
          upper?: number;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'topic_level_02_proficiencies_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'topic_level_02_proficiencies_topic_id_fkey';
            columns: ['topic_id'];
            isOneToOne: false;
            referencedRelation: 'topic_level_02_weights';
            referencedColumns: ['topic_id'];
          },
          {
            foreignKeyName: 'topic_level_02_proficiencies_topic_id_fkey';
            columns: ['topic_id'];
            isOneToOne: false;
            referencedRelation: 'topic_level_03_weights';
            referencedColumns: ['topic_level_02_id'];
          },
        ];
      };
      topic_level_03_attempts: {
        Row: {
          activity_type: Database['learning']['Enums']['activity_type'];
          actual_marks: number | null;
          created_at: string;
          denominator: number | null;
          id: string;
          max_marks: number | null;
          question_attempt_id: string;
          topic_id: number;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          activity_type: Database['learning']['Enums']['activity_type'];
          actual_marks?: number | null;
          created_at?: string;
          denominator?: number | null;
          id?: string;
          max_marks?: number | null;
          question_attempt_id: string;
          topic_id: number;
          updated_at?: string;
          user_id: string;
        };
        Update: {
          activity_type?: Database['learning']['Enums']['activity_type'];
          actual_marks?: number | null;
          created_at?: string;
          denominator?: number | null;
          id?: string;
          max_marks?: number | null;
          question_attempt_id?: string;
          topic_id?: number;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'topic_level_03_attempts_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
        ];
      };
    };
    Views: {
      assignments_available: {
        Row: {
          created_at: string | null;
          id: string | null;
          name: string | null;
          syllabus_id: number | null;
          updated_at: string | null;
        };
        Relationships: [];
      };
      streak: {
        Row: {
          end_date: string | null;
          start_date: string | null;
          streak_status: string | null;
        };
        Relationships: [];
      };
      topic_level_02_proficiencies_latest: {
        Row: {
          created_at: string | null;
          lower: number | null;
          mean: number | null;
          question_attempt_id: string | null;
          standard_deviation: number | null;
          topic_id: number | null;
          upper: number | null;
        };
        Relationships: [
          {
            foreignKeyName: 'topic_level_02_proficiencies_question_attempt_id_fkey';
            columns: ['question_attempt_id'];
            isOneToOne: false;
            referencedRelation: 'question_attempts';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'topic_level_02_proficiencies_topic_id_fkey';
            columns: ['topic_id'];
            isOneToOne: false;
            referencedRelation: 'topic_level_02_weights';
            referencedColumns: ['topic_id'];
          },
          {
            foreignKeyName: 'topic_level_02_proficiencies_topic_id_fkey';
            columns: ['topic_id'];
            isOneToOne: false;
            referencedRelation: 'topic_level_03_weights';
            referencedColumns: ['topic_level_02_id'];
          },
        ];
      };
      topic_level_02_weights: {
        Row: {
          course_level: string | null;
          syllabus_id: number | null;
          topic_id: number | null;
          weight: number | null;
        };
        Relationships: [];
      };
      topic_level_03_weights: {
        Row: {
          course_level: string | null;
          syllabus_id: number | null;
          topic_id: number | null;
          topic_level_02_id: number | null;
          weight: number | null;
        };
        Relationships: [];
      };
      user_mark_attempts_and_limits: {
        Row: {
          next_refresh: string | null;
          point_limit: number | null;
          spent_points: number | null;
          user_id: string | null;
          user_type: string | null;
        };
        Relationships: [];
      };
    };
    Functions: {
      challenge_start: {
        Args: { p_assignment_section_id: string };
        Returns: string;
      };
      create_multi_question_practice_activity: { Args: never; Returns: string };
      create_practice_activity_from_question: {
        Args: { p_metadata?: Json; p_question_id: number };
        Returns: string;
      };
      get_or_create_challenge_question_attempt: {
        Args: {
          p_challenge_activity_id: string;
          p_question_id: number;
          p_user_id: string;
        };
        Returns: string;
      };
      get_practice_activity_completion_data: {
        Args: { practice_activity_id: string };
        Returns: Json;
      };
      get_question_attempt_vote: {
        Args: { attempt_id: string };
        Returns: boolean;
      };
      has_other_attempt_for_question_in_different_activity: {
        Args: { p_question_attempt_id: string; p_question_id: number };
        Returns: boolean;
      };
      save_assessment_topics: {
        Args: { target_assessment_id: number; topics_level_02_ids: number[] };
        Returns: undefined;
      };
      set_assessment_active: {
        Args: { assessement_id: number };
        Returns: undefined;
      };
      set_question_attempt_vote: {
        Args: {
          attempt_id: string;
          question_id: number;
          user_text_feedback?: string;
          user_vote: boolean;
        };
        Returns: undefined;
      };
    };
    Enums: {
      activity_type: 'PRACTICE' | 'TEST';
      challenge_activity_question_attempt_status: 'TODO' | 'IN_PROGRESS' | 'DONE';
      challenge_activity_status: 'IN_PROGRESS' | 'SUBMITTED' | 'GRADED' | 'COMPLETED' | 'DISCARDED' | 'FAILED';
      practice_activity_status: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'DISCARDED' | 'FAILED';
      question_attempt_status: 'PENDING' | 'SUBMITTED' | 'GRADED' | 'FAILED';
    };
    CompositeTypes: {
      [_ in never]: never;
    };
  };
  public: {
    Tables: {
      exam_date_settings: {
        Row: {
          course_level: string | null;
          exam_month: string;
          id: string;
          release_days_ahead: number;
          repeat: string;
          syllabus_id: number;
        };
        Insert: {
          course_level?: string | null;
          exam_month: string;
          id?: string;
          release_days_ahead: number;
          repeat: string;
          syllabus_id: number;
        };
        Update: {
          course_level?: string | null;
          exam_month?: string;
          id?: string;
          release_days_ahead?: number;
          repeat?: string;
          syllabus_id?: number;
        };
        Relationships: [];
      };
      exam_dates: {
        Row: {
          course_level: string | null;
          created_at: string | null;
          first_exam_date: string | null;
          id: number;
          last_exam_date: string | null;
          slug: string;
          syllabus_id: number;
          updated_at: string | null;
        };
        Insert: {
          course_level?: string | null;
          created_at?: string | null;
          first_exam_date?: string | null;
          id?: never;
          last_exam_date?: string | null;
          slug: string;
          syllabus_id: number;
          updated_at?: string | null;
        };
        Update: {
          course_level?: string | null;
          created_at?: string | null;
          first_exam_date?: string | null;
          id?: never;
          last_exam_date?: string | null;
          slug?: string;
          syllabus_id?: number;
          updated_at?: string | null;
        };
        Relationships: [];
      };
      llm_chat_message_user_feedback: {
        Row: {
          author: string;
          created_at: string;
          id: number;
          score: number;
          text_feedback: string;
        };
        Insert: {
          author: string;
          created_at?: string;
          id: number;
          score: number;
          text_feedback: string;
        };
        Update: {
          author?: string;
          created_at?: string;
          id?: number;
          score?: number;
          text_feedback?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'llm_chat_message_user_feedback_id_fkey';
            columns: ['id'];
            isOneToOne: true;
            referencedRelation: 'llm_chat_messages';
            referencedColumns: ['id'];
          },
        ];
      };
      llm_chat_messages: {
        Row: {
          author: string | null;
          created_at: string;
          created_by_role: Database['public']['Enums']['ai_chat_role_enum'];
          id: number;
          input_tokens: number | null;
          llm_chat_id: number;
          message: Json;
          metadata: Json | null;
          output_tokens: number | null;
          responds_to: number | null;
          stop_reason: string | null;
        };
        Insert: {
          author?: string | null;
          created_at?: string;
          created_by_role: Database['public']['Enums']['ai_chat_role_enum'];
          id?: number;
          input_tokens?: number | null;
          llm_chat_id: number;
          message: Json;
          metadata?: Json | null;
          output_tokens?: number | null;
          responds_to?: number | null;
          stop_reason?: string | null;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          created_by_role?: Database['public']['Enums']['ai_chat_role_enum'];
          id?: number;
          input_tokens?: number | null;
          llm_chat_id?: number;
          message?: Json;
          metadata?: Json | null;
          output_tokens?: number | null;
          responds_to?: number | null;
          stop_reason?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'llm_chat_messages_llm_chat_id_fkey';
            columns: ['llm_chat_id'];
            isOneToOne: false;
            referencedRelation: 'llm_chats';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'llm_chat_messages_responds_to_fkey';
            columns: ['responds_to'];
            isOneToOne: false;
            referencedRelation: 'llm_chat_messages';
            referencedColumns: ['id'];
          },
        ];
      };
      llm_chats: {
        Row: {
          id: number;
        };
        Insert: {
          id?: number;
        };
        Update: {
          id?: number;
        };
        Relationships: [];
      };
      mark_history: {
        Row: {
          created_at: string;
          feedback: string | null;
          id: number;
          initiator: string | null;
          marks: Json | null;
          question_engagement_id: number;
          thinking: string | null;
        };
        Insert: {
          created_at?: string;
          feedback?: string | null;
          id?: number;
          initiator?: string | null;
          marks?: Json | null;
          question_engagement_id: number;
          thinking?: string | null;
        };
        Update: {
          created_at?: string;
          feedback?: string | null;
          id?: number;
          initiator?: string | null;
          marks?: Json | null;
          question_engagement_id?: number;
          thinking?: string | null;
        };
        Relationships: [];
      };
      question_image_snapshots: {
        Row: {
          author: string | null;
          created_at: string;
          description: Json | null;
          id: number;
          question_id: number | null;
          question_image_bucket: string | null;
          question_image_name: string | null;
          question_snapshot_id: number;
          snapshot_id: number;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at?: string;
          description?: Json | null;
          id?: number;
          question_id?: number | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          question_snapshot_id: number;
          snapshot_id?: never;
          sys_period?: unknown;
          updated_at?: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          description?: Json | null;
          id?: number;
          question_id?: number | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          question_snapshot_id?: number;
          snapshot_id?: never;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'question_image_snapshots_question_snapshot_id_fkey';
            columns: ['question_snapshot_id'];
            isOneToOne: false;
            referencedRelation: 'question_snapshots';
            referencedColumns: ['snapshot_id'];
          },
        ];
      };
      question_images: {
        Row: {
          author: string | null;
          created_at: string;
          description: Json | null;
          id: number;
          question_id: number | null;
          question_image_bucket: string | null;
          question_image_name: string | null;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at?: string;
          description?: Json | null;
          id?: number;
          question_id?: number | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          sys_period?: unknown;
          updated_at?: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          description?: Json | null;
          id?: number;
          question_id?: number | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'question_images_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'admin_question_list_view';
            referencedColumns: ['question_id'];
          },
          {
            foreignKeyName: 'question_images_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_question_items_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'question_images_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_questions';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'question_images_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'questions';
            referencedColumns: ['id'];
          },
        ];
      };
      question_images_history: {
        Row: {
          author: string | null;
          created_at: string;
          description: Json | null;
          history_id: string;
          id: number;
          question_id: number | null;
          question_image_bucket: string | null;
          question_image_name: string | null;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at: string;
          description?: Json | null;
          history_id?: string;
          id: number;
          question_id?: number | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          sys_period: unknown;
          updated_at: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          description?: Json | null;
          history_id?: string;
          id?: number;
          question_id?: number | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [];
      };
      question_operations: {
        Row: {
          created_at: string;
          id: string;
          model_name: string | null;
          operation: string;
          question_id: number;
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          id?: string;
          model_name?: string | null;
          operation: string;
          question_id: number;
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          id?: string;
          model_name?: string | null;
          operation?: string;
          question_id?: number;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'question_operations_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'admin_question_list_view';
            referencedColumns: ['question_id'];
          },
          {
            foreignKeyName: 'question_operations_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_question_items_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'question_operations_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_questions';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'question_operations_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'questions';
            referencedColumns: ['id'];
          },
        ];
      };
      question_snapshots: {
        Row: {
          author: string | null;
          calculator_allowed: boolean;
          created_at: string;
          feedback: Json | null;
          generation_run_id: string | null;
          id: number;
          image_llm_feedback: Json | null;
          items: Database['public']['CompositeTypes']['question_item_ref'][];
          llm_feedback: Json | null;
          max_points: number | null;
          question_items: Json | null;
          question_number: number;
          reference_question_id: number | null;
          snapshot_id: number;
          solution_paths: Json | null;
          status: Database['public']['Enums']['question_status'];
          sys_period: unknown;
          updated_at: string;
          updated_by: string | null;
        };
        Insert: {
          author?: string | null;
          calculator_allowed: boolean;
          created_at?: string;
          feedback?: Json | null;
          generation_run_id?: string | null;
          id?: number;
          image_llm_feedback?: Json | null;
          items?: Database['public']['CompositeTypes']['question_item_ref'][];
          llm_feedback?: Json | null;
          max_points?: number | null;
          question_items?: Json | null;
          question_number: number;
          reference_question_id?: number | null;
          snapshot_id?: never;
          solution_paths?: Json | null;
          status?: Database['public']['Enums']['question_status'];
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
        };
        Update: {
          author?: string | null;
          calculator_allowed?: boolean;
          created_at?: string;
          feedback?: Json | null;
          generation_run_id?: string | null;
          id?: number;
          image_llm_feedback?: Json | null;
          items?: Database['public']['CompositeTypes']['question_item_ref'][];
          llm_feedback?: Json | null;
          max_points?: number | null;
          question_items?: Json | null;
          question_number?: number;
          reference_question_id?: number | null;
          snapshot_id?: never;
          solution_paths?: Json | null;
          status?: Database['public']['Enums']['question_status'];
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
        };
        Relationships: [];
      };
      question_solution_path_topic_points: {
        Row: {
          cdc_path: string | null;
          denominator: number;
          path: Json;
          points: number;
          question_id: number;
          topic_id: number;
        };
        Insert: {
          cdc_path?: string | null;
          denominator?: number;
          path: Json;
          points: number;
          question_id: number;
          topic_id: number;
        };
        Update: {
          cdc_path?: string | null;
          denominator?: number;
          path?: Json;
          points?: number;
          question_id?: number;
          topic_id?: number;
        };
        Relationships: [
          {
            foreignKeyName: 'question_solution_path_topic_points_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'admin_question_list_view';
            referencedColumns: ['question_id'];
          },
          {
            foreignKeyName: 'question_solution_path_topic_points_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_question_items_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'question_solution_path_topic_points_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_questions';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'question_solution_path_topic_points_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'questions';
            referencedColumns: ['id'];
          },
        ];
      };
      questions: {
        Row: {
          author: string | null;
          calculator_allowed: boolean;
          created_at: string;
          feedback: Json | null;
          generation_run_id: string | null;
          id: number;
          image_llm_feedback: Json | null;
          items: Database['public']['CompositeTypes']['question_item_ref'][];
          llm_feedback: Json | null;
          max_points: number | null;
          metadata: Json | null;
          question_items: Json | null;
          question_items_public: Json | null;
          question_number: number;
          reference_question_id: number;
          solution_paths: Json | null;
          status: Database['public']['Enums']['question_status'];
          sys_period: unknown;
          updated_at: string;
          updated_by: string | null;
        };
        Insert: {
          author?: string | null;
          calculator_allowed: boolean;
          created_at?: string;
          feedback?: Json | null;
          generation_run_id?: string | null;
          id?: number;
          image_llm_feedback?: Json | null;
          items?: Database['public']['CompositeTypes']['question_item_ref'][];
          llm_feedback?: Json | null;
          max_points?: number | null;
          metadata?: Json | null;
          question_items?: Json | null;
          question_items_public?: Json | null;
          question_number: number;
          reference_question_id: number;
          solution_paths?: Json | null;
          status?: Database['public']['Enums']['question_status'];
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
        };
        Update: {
          author?: string | null;
          calculator_allowed?: boolean;
          created_at?: string;
          feedback?: Json | null;
          generation_run_id?: string | null;
          id?: number;
          image_llm_feedback?: Json | null;
          items?: Database['public']['CompositeTypes']['question_item_ref'][];
          llm_feedback?: Json | null;
          max_points?: number | null;
          metadata?: Json | null;
          question_items?: Json | null;
          question_items_public?: Json | null;
          question_number?: number;
          reference_question_id?: number;
          solution_paths?: Json | null;
          status?: Database['public']['Enums']['question_status'];
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'questions_reference_question_id_fkey';
            columns: ['reference_question_id'];
            isOneToOne: false;
            referencedRelation: 'admin_reference_question_list_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'questions_reference_question_id_fkey';
            columns: ['reference_question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_question_items_view';
            referencedColumns: ['reference_question_id'];
          },
          {
            foreignKeyName: 'questions_reference_question_id_fkey';
            columns: ['reference_question_id'];
            isOneToOne: false;
            referencedRelation: 'reference_question_items_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'questions_reference_question_id_fkey';
            columns: ['reference_question_id'];
            isOneToOne: false;
            referencedRelation: 'reference_questions';
            referencedColumns: ['id'];
          },
        ];
      };
      questions_history: {
        Row: {
          author: string | null;
          calculator_allowed: boolean;
          created_at: string;
          feedback: Json | null;
          generation_run_id: string | null;
          history_id: string;
          id: number;
          markscheme_items_historical: Json[] | null;
          question_items: Json | null;
          question_number: number;
          reference_question_id: number | null;
          status: Database['public']['Enums']['question_status'];
          sys_period: unknown;
          updated_at: string;
          updated_by: string | null;
        };
        Insert: {
          author?: string | null;
          calculator_allowed: boolean;
          created_at: string;
          feedback?: Json | null;
          generation_run_id?: string | null;
          history_id?: string;
          id: number;
          markscheme_items_historical?: Json[] | null;
          question_items?: Json | null;
          question_number: number;
          reference_question_id?: number | null;
          status: Database['public']['Enums']['question_status'];
          sys_period: unknown;
          updated_at: string;
          updated_by?: string | null;
        };
        Update: {
          author?: string | null;
          calculator_allowed?: boolean;
          created_at?: string;
          feedback?: Json | null;
          generation_run_id?: string | null;
          history_id?: string;
          id?: number;
          markscheme_items_historical?: Json[] | null;
          question_items?: Json | null;
          question_number?: number;
          reference_question_id?: number | null;
          status?: Database['public']['Enums']['question_status'];
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
        };
        Relationships: [];
      };
      reference_question_markscheme_images: {
        Row: {
          created_at: string | null;
          created_by: string | null;
          id: number;
          image_bucket: string | null;
          image_name: string;
          reference_question: number;
          sort_order: number;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          created_at?: string | null;
          created_by?: string | null;
          id?: number;
          image_bucket?: string | null;
          image_name: string;
          reference_question: number;
          sort_order: number;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          created_at?: string | null;
          created_by?: string | null;
          id?: number;
          image_bucket?: string | null;
          image_name?: string;
          reference_question?: number;
          sort_order?: number;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'reference_question_markscheme_images_reference_question_fkey';
            columns: ['reference_question'];
            isOneToOne: false;
            referencedRelation: 'admin_reference_question_list_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'reference_question_markscheme_images_reference_question_fkey';
            columns: ['reference_question'];
            isOneToOne: false;
            referencedRelation: 'derivative_question_items_view';
            referencedColumns: ['reference_question_id'];
          },
          {
            foreignKeyName: 'reference_question_markscheme_images_reference_question_fkey';
            columns: ['reference_question'];
            isOneToOne: false;
            referencedRelation: 'reference_question_items_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'reference_question_markscheme_images_reference_question_fkey';
            columns: ['reference_question'];
            isOneToOne: false;
            referencedRelation: 'reference_questions';
            referencedColumns: ['id'];
          },
        ];
      };
      reference_question_snapshots: {
        Row: {
          calculator_allowed: boolean | null;
          course_levels: string[] | null;
          created_at: string | null;
          created_by: string | null;
          human_feedback: string | null;
          id: number;
          llm_feedback: Json | null;
          metadata: Json | null;
          question_items: Json | null;
          question_labels: string[] | null;
          question_number: number;
          snapshot_id: number;
          source_id: string | null;
          source_ref: Json;
          status: string | null;
          status_reason: string | null;
          syllabus_id: number | null;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          calculator_allowed?: boolean | null;
          course_levels?: string[] | null;
          created_at?: string | null;
          created_by?: string | null;
          human_feedback?: string | null;
          id: number;
          llm_feedback?: Json | null;
          metadata?: Json | null;
          question_items?: Json | null;
          question_labels?: string[] | null;
          question_number: number;
          snapshot_id?: never;
          source_id?: string | null;
          source_ref?: Json;
          status?: string | null;
          status_reason?: string | null;
          syllabus_id?: number | null;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          calculator_allowed?: boolean | null;
          course_levels?: string[] | null;
          created_at?: string | null;
          created_by?: string | null;
          human_feedback?: string | null;
          id?: number;
          llm_feedback?: Json | null;
          metadata?: Json | null;
          question_items?: Json | null;
          question_labels?: string[] | null;
          question_number?: number;
          snapshot_id?: never;
          source_id?: string | null;
          source_ref?: Json;
          status?: string | null;
          status_reason?: string | null;
          syllabus_id?: number | null;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'reference_question_snapshots_source_id_fkey';
            columns: ['source_id'];
            isOneToOne: false;
            referencedRelation: 'admin_source_items_view';
            referencedColumns: ['id'];
          },
        ];
      };
      reference_questions: {
        Row: {
          course_levels: string[] | null;
          created_at: string | null;
          created_by: string | null;
          human_feedback: string | null;
          id: number;
          llm_feedback: Json | null;
          markscheme_image_bucket: string | null;
          markscheme_image_name: string | null;
          metadata: Json | null;
          parsed_markscheme: Json | null;
          parsed_markscheme_llm_feedback: Json | null;
          question_image_bucket: string | null;
          question_image_name: string | null;
          question_items: Json | null;
          question_labels: string[] | null;
          question_number: number;
          solution_paths: Json | null;
          source_id: string | null;
          source_ref: Json;
          status: Database['public']['Enums']['reference_question_status'] | null;
          status_reason: string | null;
          syllabus_id: number | null;
          sys_period: unknown;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          course_levels?: string[] | null;
          created_at?: string | null;
          created_by?: string | null;
          human_feedback?: string | null;
          id?: never;
          llm_feedback?: Json | null;
          markscheme_image_bucket?: string | null;
          markscheme_image_name?: string | null;
          metadata?: Json | null;
          parsed_markscheme?: Json | null;
          parsed_markscheme_llm_feedback?: Json | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          question_items?: Json | null;
          question_labels?: string[] | null;
          question_number: number;
          solution_paths?: Json | null;
          source_id?: string | null;
          source_ref?: Json;
          status?: Database['public']['Enums']['reference_question_status'] | null;
          status_reason?: string | null;
          syllabus_id?: number | null;
          sys_period?: unknown;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          course_levels?: string[] | null;
          created_at?: string | null;
          created_by?: string | null;
          human_feedback?: string | null;
          id?: never;
          llm_feedback?: Json | null;
          markscheme_image_bucket?: string | null;
          markscheme_image_name?: string | null;
          metadata?: Json | null;
          parsed_markscheme?: Json | null;
          parsed_markscheme_llm_feedback?: Json | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          question_items?: Json | null;
          question_labels?: string[] | null;
          question_number?: number;
          solution_paths?: Json | null;
          source_id?: string | null;
          source_ref?: Json;
          status?: Database['public']['Enums']['reference_question_status'] | null;
          status_reason?: string | null;
          syllabus_id?: number | null;
          sys_period?: unknown;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'reference_questions_source_id_fkey';
            columns: ['source_id'];
            isOneToOne: false;
            referencedRelation: 'admin_source_items_view';
            referencedColumns: ['id'];
          },
        ];
      };
      reference_questions_history: {
        Row: {
          calculator_allowed: boolean | null;
          course_levels: string[] | null;
          created_at: string | null;
          created_by: string | null;
          human_feedback: string | null;
          id: number;
          llm_feedback: Json | null;
          markscheme_image_bucket: string | null;
          markscheme_image_name: string | null;
          metadata: Json | null;
          parsed_markscheme: Json | null;
          parsed_markscheme_llm_feedback: Json | null;
          question_image_bucket: string | null;
          question_image_name: string | null;
          question_items: Json | null;
          question_labels: string[] | null;
          question_number: number;
          source_id: string | null;
          source_ref: Json;
          status: Database['public']['Enums']['reference_question_status'] | null;
          status_reason: string | null;
          syllabus_id: number | null;
          sys_period: unknown;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          calculator_allowed?: boolean | null;
          course_levels?: string[] | null;
          created_at?: string | null;
          created_by?: string | null;
          human_feedback?: string | null;
          id: number;
          llm_feedback?: Json | null;
          markscheme_image_bucket?: string | null;
          markscheme_image_name?: string | null;
          metadata?: Json | null;
          parsed_markscheme?: Json | null;
          parsed_markscheme_llm_feedback?: Json | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          question_items?: Json | null;
          question_labels?: string[] | null;
          question_number: number;
          source_id?: string | null;
          source_ref: Json;
          status?: Database['public']['Enums']['reference_question_status'] | null;
          status_reason?: string | null;
          syllabus_id?: number | null;
          sys_period: unknown;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          calculator_allowed?: boolean | null;
          course_levels?: string[] | null;
          created_at?: string | null;
          created_by?: string | null;
          human_feedback?: string | null;
          id?: number;
          llm_feedback?: Json | null;
          markscheme_image_bucket?: string | null;
          markscheme_image_name?: string | null;
          metadata?: Json | null;
          parsed_markscheme?: Json | null;
          parsed_markscheme_llm_feedback?: Json | null;
          question_image_bucket?: string | null;
          question_image_name?: string | null;
          question_items?: Json | null;
          question_labels?: string[] | null;
          question_number?: number;
          source_id?: string | null;
          source_ref?: Json;
          status?: Database['public']['Enums']['reference_question_status'] | null;
          status_reason?: string | null;
          syllabus_id?: number | null;
          sys_period?: unknown;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [];
      };
      schools: {
        Row: {
          code: string;
          coordinator: string | null;
          country: string | null;
          director: string | null;
          id: string;
          languages: string[] | null;
          link: string | null;
          name: string;
          program: Database['categories']['Enums']['program'];
          regions: string | null;
          session: string | null;
          since: string | null;
          type: string | null;
          website: string | null;
        };
        Insert: {
          code: string;
          coordinator?: string | null;
          country?: string | null;
          director?: string | null;
          id?: string;
          languages?: string[] | null;
          link?: string | null;
          name: string;
          program: Database['categories']['Enums']['program'];
          regions?: string | null;
          session?: string | null;
          since?: string | null;
          type?: string | null;
          website?: string | null;
        };
        Update: {
          code?: string;
          coordinator?: string | null;
          country?: string | null;
          director?: string | null;
          id?: string;
          languages?: string[] | null;
          link?: string | null;
          name?: string;
          program?: Database['categories']['Enums']['program'];
          regions?: string | null;
          session?: string | null;
          since?: string | null;
          type?: string | null;
          website?: string | null;
        };
        Relationships: [];
      };
      settings: {
        Row: {
          author: string | null;
          created_at: string;
          daily_marks_attempted_limit_free_users: number;
          daily_marks_attempted_limit_paid_users: number;
          id: number;
          sys_period: unknown;
          updated_at: string;
          weekly_marks_attempted_limit_free_users: number;
          weekly_marks_attempted_limit_paid_users: number;
        };
        Insert: {
          author?: string | null;
          created_at?: string;
          daily_marks_attempted_limit_free_users: number;
          daily_marks_attempted_limit_paid_users: number;
          id?: number;
          sys_period?: unknown;
          updated_at?: string;
          weekly_marks_attempted_limit_free_users?: number;
          weekly_marks_attempted_limit_paid_users?: number;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          daily_marks_attempted_limit_free_users?: number;
          daily_marks_attempted_limit_paid_users?: number;
          id?: number;
          sys_period?: unknown;
          updated_at?: string;
          weekly_marks_attempted_limit_free_users?: number;
          weekly_marks_attempted_limit_paid_users?: number;
        };
        Relationships: [];
      };
      settings_history: {
        Row: {
          author: string | null;
          created_at: string;
          daily_marks_attempted_limit_free_users: number;
          daily_marks_attempted_limit_paid_users: number;
          history_id: string;
          id: number;
          sys_period: unknown;
          updated_at: string;
          weekly_marks_attempted_limit_free_users: number;
          weekly_marks_attempted_limit_paid_users: number;
        };
        Insert: {
          author?: string | null;
          created_at: string;
          daily_marks_attempted_limit_free_users: number;
          daily_marks_attempted_limit_paid_users: number;
          history_id?: string;
          id: number;
          sys_period: unknown;
          updated_at: string;
          weekly_marks_attempted_limit_free_users?: number;
          weekly_marks_attempted_limit_paid_users?: number;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          daily_marks_attempted_limit_free_users?: number;
          daily_marks_attempted_limit_paid_users?: number;
          history_id?: string;
          id?: number;
          sys_period?: unknown;
          updated_at?: string;
          weekly_marks_attempted_limit_free_users?: number;
          weekly_marks_attempted_limit_paid_users?: number;
        };
        Relationships: [];
      };
      stem_snapshots: {
        Row: {
          author: string | null;
          created_at: string;
          id: number;
          markscheme: Json | null;
          question_id: number | null;
          question_snapshot_id: number;
          snapshot_id: number;
          stem: unknown[];
          sys_period: unknown;
          total_marks: number | null;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at?: string;
          id?: number;
          markscheme?: Json | null;
          question_id?: number | null;
          question_snapshot_id: number;
          snapshot_id?: never;
          stem: unknown[];
          sys_period?: unknown;
          total_marks?: number | null;
          updated_at?: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          id?: number;
          markscheme?: Json | null;
          question_id?: number | null;
          question_snapshot_id?: number;
          snapshot_id?: never;
          stem?: unknown[];
          sys_period?: unknown;
          total_marks?: number | null;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'stem_snapshots_question_snapshot_id_fkey';
            columns: ['question_snapshot_id'];
            isOneToOne: false;
            referencedRelation: 'question_snapshots';
            referencedColumns: ['snapshot_id'];
          },
        ];
      };
      stems: {
        Row: {
          author: string | null;
          created_at: string;
          id: number;
          markscheme: Json | null;
          question_id: number | null;
          stem: unknown[];
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at?: string;
          id?: number;
          markscheme?: Json | null;
          question_id?: number | null;
          stem: unknown[];
          sys_period?: unknown;
          updated_at?: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          id?: number;
          markscheme?: Json | null;
          question_id?: number | null;
          stem?: unknown[];
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'stems_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'admin_question_list_view';
            referencedColumns: ['question_id'];
          },
          {
            foreignKeyName: 'stems_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_question_items_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'stems_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_questions';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'stems_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'questions';
            referencedColumns: ['id'];
          },
        ];
      };
      stems_history: {
        Row: {
          author: string | null;
          created_at: string;
          history_id: string;
          id: number;
          question_id: number | null;
          stem: unknown[];
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at: string;
          history_id?: string;
          id: number;
          question_id?: number | null;
          stem: unknown[];
          sys_period: unknown;
          updated_at: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          history_id?: string;
          id?: number;
          question_id?: number | null;
          stem?: unknown[];
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [];
      };
      stimuli: {
        Row: {
          author: string | null;
          created_at: string;
          id: number;
          question_id: number | null;
          stimulus: Json;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at?: string;
          id?: number;
          question_id?: number | null;
          stimulus: Json;
          sys_period?: unknown;
          updated_at?: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          id?: number;
          question_id?: number | null;
          stimulus?: Json;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'stimuli_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'admin_question_list_view';
            referencedColumns: ['question_id'];
          },
          {
            foreignKeyName: 'stimuli_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_question_items_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'stimuli_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_questions';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'stimuli_question_id_fkey';
            columns: ['question_id'];
            isOneToOne: false;
            referencedRelation: 'questions';
            referencedColumns: ['id'];
          },
        ];
      };
      stimuli_history: {
        Row: {
          author: string | null;
          created_at: string;
          history_id: string;
          id: number;
          question_id: number | null;
          stimulus: Json;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at: string;
          history_id?: string;
          id: number;
          question_id?: number | null;
          stimulus: Json;
          sys_period: unknown;
          updated_at: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          history_id?: string;
          id?: number;
          question_id?: number | null;
          stimulus?: Json;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [];
      };
      stimulus_snapshots: {
        Row: {
          author: string | null;
          created_at: string;
          id: number;
          question_id: number | null;
          question_snapshot_id: number;
          snapshot_id: number;
          stimulus: Json;
          sys_period: unknown;
          updated_at: string;
        };
        Insert: {
          author?: string | null;
          created_at?: string;
          id?: number;
          question_id?: number | null;
          question_snapshot_id: number;
          snapshot_id?: never;
          stimulus: Json;
          sys_period?: unknown;
          updated_at?: string;
        };
        Update: {
          author?: string | null;
          created_at?: string;
          id?: number;
          question_id?: number | null;
          question_snapshot_id?: number;
          snapshot_id?: never;
          stimulus?: Json;
          sys_period?: unknown;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'stimulus_snapshots_question_snapshot_id_fkey';
            columns: ['question_snapshot_id'];
            isOneToOne: false;
            referencedRelation: 'question_snapshots';
            referencedColumns: ['snapshot_id'];
          },
        ];
      };
      user_role_bindings: {
        Row: {
          created_at: string;
          id: string;
          role: Database['public']['Enums']['user_role'];
          sys_period: unknown;
          updated_at: string | null;
        };
        Insert: {
          created_at?: string;
          id: string;
          role: Database['public']['Enums']['user_role'];
          sys_period?: unknown;
          updated_at?: string | null;
        };
        Update: {
          created_at?: string;
          id?: string;
          role?: Database['public']['Enums']['user_role'];
          sys_period?: unknown;
          updated_at?: string | null;
        };
        Relationships: [];
      };
      user_role_bindings_history: {
        Row: {
          created_at: string;
          id: string;
          role: Database['public']['Enums']['user_role'];
          sys_period: unknown;
          updated_at: string | null;
        };
        Insert: {
          created_at: string;
          id: string;
          role: Database['public']['Enums']['user_role'];
          sys_period: unknown;
          updated_at?: string | null;
        };
        Update: {
          created_at?: string;
          id?: string;
          role?: Database['public']['Enums']['user_role'];
          sys_period?: unknown;
          updated_at?: string | null;
        };
        Relationships: [];
      };
      user_settings: {
        Row: {
          app_theme: Database['public']['Enums']['user_color_scheme'];
          notifications: Json | null;
          timezone: string;
          user_id: string;
        };
        Insert: {
          app_theme?: Database['public']['Enums']['user_color_scheme'];
          notifications?: Json | null;
          timezone?: string;
          user_id: string;
        };
        Update: {
          app_theme?: Database['public']['Enums']['user_color_scheme'];
          notifications?: Json | null;
          timezone?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      users: {
        Row: {
          course_level: string | null;
          created_at: string | null;
          current_onboarding_step: Database['public']['Enums']['onboarding_step'] | null;
          email: string;
          final_exam_date: string | null;
          first_name: string | null;
          id: string;
          last_name: string | null;
          last_sign_in_at: string | null;
          onboarded_app: boolean | null;
          onboarded_topic_practice: boolean | null;
          origin: Database['public']['Enums']['user_origin'] | null;
          practice_submitted: boolean;
          profession: Database['public']['Enums']['user_profession'] | null;
          profile_pic: string | null;
          program: Database['categories']['Enums']['program'] | null;
          school_name: string | null;
          streak_goal: number | null;
          syllabus_id: number | null;
          sys_period: unknown;
          updated_at: string | null;
        };
        Insert: {
          course_level?: string | null;
          created_at?: string | null;
          current_onboarding_step?: Database['public']['Enums']['onboarding_step'] | null;
          email: string;
          final_exam_date?: string | null;
          first_name?: string | null;
          id: string;
          last_name?: string | null;
          last_sign_in_at?: string | null;
          onboarded_app?: boolean | null;
          onboarded_topic_practice?: boolean | null;
          origin?: Database['public']['Enums']['user_origin'] | null;
          practice_submitted?: boolean;
          profession?: Database['public']['Enums']['user_profession'] | null;
          profile_pic?: string | null;
          program?: Database['categories']['Enums']['program'] | null;
          school_name?: string | null;
          streak_goal?: number | null;
          syllabus_id?: number | null;
          sys_period?: unknown;
          updated_at?: string | null;
        };
        Update: {
          course_level?: string | null;
          created_at?: string | null;
          current_onboarding_step?: Database['public']['Enums']['onboarding_step'] | null;
          email?: string;
          final_exam_date?: string | null;
          first_name?: string | null;
          id?: string;
          last_name?: string | null;
          last_sign_in_at?: string | null;
          onboarded_app?: boolean | null;
          onboarded_topic_practice?: boolean | null;
          origin?: Database['public']['Enums']['user_origin'] | null;
          practice_submitted?: boolean;
          profession?: Database['public']['Enums']['user_profession'] | null;
          profile_pic?: string | null;
          program?: Database['categories']['Enums']['program'] | null;
          school_name?: string | null;
          streak_goal?: number | null;
          syllabus_id?: number | null;
          sys_period?: unknown;
          updated_at?: string | null;
        };
        Relationships: [];
      };
      users_history: {
        Row: {
          cdc_sys_period: Json | null;
          course_level: string | null;
          current_onboarding_step: Database['public']['Enums']['onboarding_step'] | null;
          email: string;
          final_exam_date: string | null;
          first_name: string | null;
          history_id: string;
          id: string;
          last_name: string | null;
          onboarded_app: boolean | null;
          onboarded_topic_practice: boolean | null;
          origin: Database['public']['Enums']['user_origin'] | null;
          practice_submitted: boolean | null;
          profession: Database['public']['Enums']['user_profession'] | null;
          profile_pic: string | null;
          program: Database['categories']['Enums']['program'] | null;
          school_name: string | null;
          storage: Json | null;
          streak_goal: number | null;
          syllabus_id: number | null;
          sys_period: unknown;
        };
        Insert: {
          cdc_sys_period?: Json | null;
          course_level?: string | null;
          current_onboarding_step?: Database['public']['Enums']['onboarding_step'] | null;
          email: string;
          final_exam_date?: string | null;
          first_name?: string | null;
          history_id?: string;
          id: string;
          last_name?: string | null;
          onboarded_app?: boolean | null;
          onboarded_topic_practice?: boolean | null;
          origin?: Database['public']['Enums']['user_origin'] | null;
          practice_submitted?: boolean | null;
          profession?: Database['public']['Enums']['user_profession'] | null;
          profile_pic?: string | null;
          program?: Database['categories']['Enums']['program'] | null;
          school_name?: string | null;
          storage?: Json | null;
          streak_goal?: number | null;
          syllabus_id?: number | null;
          sys_period: unknown;
        };
        Update: {
          cdc_sys_period?: Json | null;
          course_level?: string | null;
          current_onboarding_step?: Database['public']['Enums']['onboarding_step'] | null;
          email?: string;
          final_exam_date?: string | null;
          first_name?: string | null;
          history_id?: string;
          id?: string;
          last_name?: string | null;
          onboarded_app?: boolean | null;
          onboarded_topic_practice?: boolean | null;
          origin?: Database['public']['Enums']['user_origin'] | null;
          practice_submitted?: boolean | null;
          profession?: Database['public']['Enums']['user_profession'] | null;
          profile_pic?: string | null;
          program?: Database['categories']['Enums']['program'] | null;
          school_name?: string | null;
          storage?: Json | null;
          streak_goal?: number | null;
          syllabus_id?: number | null;
          sys_period?: unknown;
        };
        Relationships: [];
      };
    };
    Views: {
      admin_payout_requests_view: {
        Row: {
          attachments: Json | null;
          created_at: string | null;
          current_hourly_rate: number | null;
          extra_bonus_in_eur: number | null;
          extra_bonus_reason: string | null;
          final_payout_in_eur: number | null;
          hours: Json | null;
          id: string | null;
          payout_rate_id: string | null;
          performance_bonus_in_eur: number | null;
          period: string | null;
          status: Database['billing']['Enums']['payout_request_status'] | null;
          status_reason: string | null;
          target_account_id: number | null;
          transaction_id: string | null;
          transfer_id: number | null;
          updated_at: string | null;
          user_email: string | null;
          user_id: string | null;
          user_name: string | null;
        };
        Relationships: [];
      };
      admin_question_list_view: {
        Row: {
          author: string | null;
          author_name: string | null;
          created_at: string | null;
          items: Json | null;
          question_id: number | null;
          status: string | null;
          type: string | null;
          updated_at: string | null;
        };
        Relationships: [];
      };
      admin_reference_question_list_view: {
        Row: {
          author_name: string | null;
          created_at: string | null;
          created_by: string | null;
          id: number | null;
          question_labels: string[] | null;
          question_number: number | null;
          source_ref: Json | null;
          status: Database['public']['Enums']['reference_question_status'] | null;
          status_reason: string | null;
          statuses: Json | null;
          type: string | null;
          updated_at: string | null;
        };
        Relationships: [];
      };
      admin_source_items_view: {
        Row: {
          created_at: string | null;
          document_type: Database['question_bank']['Enums']['document_type'] | null;
          id: string | null;
          name: string | null;
          program: Database['categories']['Enums']['program'] | null;
          raw_source: Json | null;
          ref_questions: Json | null;
          source_type: Database['question_bank']['Enums']['source_type'] | null;
          status: Database['question_bank']['Enums']['source_status'] | null;
          subject: Database['categories']['Enums']['subject'] | null;
          syllabus_id: number | null;
          tier: number | null;
          updated_at: string | null;
          user_email: string | null;
        };
        Relationships: [];
      };
      admin_users_list_view: {
        Row: {
          assigned_syllabuses: Database['review']['Tables']['user_review_mode_bindings']['Row'][] | null;
          email: string | null;
          first_name: string | null;
          id: string | null;
          joined_date: string | null;
          last_name: string | null;
          role: Database['public']['Enums']['user_role'] | null;
        };
        Relationships: [];
      };
      derivative_question_items_view: {
        Row: {
          created_at: string | null;
          id: number | null;
          markscheme_image_count: number | null;
          other_published_derivative_questions: number[] | null;
          question_image_count: number | null;
          question_number: number | null;
          reference_question_id: number | null;
          reference_question_status: Database['public']['Enums']['reference_question_status'] | null;
          source_id: string | null;
          source_name: string | null;
          source_status: string | null;
          status: Database['public']['Enums']['question_status'] | null;
          syllabus_id: number | null;
          topics: Json | null;
          total_marks: number | null;
          total_stems: number | null;
          type: string | null;
          updated_at: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'reference_questions_source_id_fkey';
            columns: ['source_id'];
            isOneToOne: false;
            referencedRelation: 'admin_source_items_view';
            referencedColumns: ['id'];
          },
        ];
      };
      derivative_questions: {
        Row: {
          attempted: boolean | null;
          author: string | null;
          calculator_allowed: boolean | null;
          course_levels: string[] | null;
          created_at: string | null;
          difficulty: string | null;
          feedback: Json | null;
          generation_run_id: string | null;
          id: number | null;
          image_llm_feedback: Json | null;
          items: Database['public']['CompositeTypes']['question_item_ref'][] | null;
          llm_feedback: Json | null;
          max_points: number | null;
          metadata: Json | null;
          question_items: Json | null;
          question_items_public: Json | null;
          question_number: number | null;
          reference_question_id: number | null;
          solution_paths: Json | null;
          status: Database['public']['Enums']['question_status'] | null;
          syllabus_id: number | null;
          sys_period: unknown;
          topic_level_02_ids: number[] | null;
          type: Database['public']['Enums']['question_type'] | null;
          updated_at: string | null;
          updated_by: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'questions_reference_question_id_fkey';
            columns: ['reference_question_id'];
            isOneToOne: false;
            referencedRelation: 'admin_reference_question_list_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'questions_reference_question_id_fkey';
            columns: ['reference_question_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_question_items_view';
            referencedColumns: ['reference_question_id'];
          },
          {
            foreignKeyName: 'questions_reference_question_id_fkey';
            columns: ['reference_question_id'];
            isOneToOne: false;
            referencedRelation: 'reference_question_items_view';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'questions_reference_question_id_fkey';
            columns: ['reference_question_id'];
            isOneToOne: false;
            referencedRelation: 'reference_questions';
            referencedColumns: ['id'];
          },
        ];
      };
      reference_question_items_view: {
        Row: {
          created_at: string | null;
          id: number | null;
          markscheme_image_count: number | null;
          published_derivative_questions: number[] | null;
          question_image_count: number | null;
          question_number: number | null;
          source_id: string | null;
          source_name: string | null;
          source_status: string | null;
          status: Database['public']['Enums']['reference_question_status'] | null;
          syllabus_id: number | null;
          topics: Json | null;
          total_marks: number | null;
          total_stems: number | null;
          type: string | null;
          updated_at: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'reference_questions_source_id_fkey';
            columns: ['source_id'];
            isOneToOne: false;
            referencedRelation: 'admin_source_items_view';
            referencedColumns: ['id'];
          },
        ];
      };
    };
    Functions: {
      admin_update_user_role: {
        Args: {
          new_role: Database['public']['Enums']['user_role'];
          user_id: string;
        };
        Returns: undefined;
      };
      can_create_question_engagement_status: {
        Args: {
          affected_question_engagement_id: number;
          new_status: Database['public']['Enums']['question_engagement_status'];
        };
        Returns: boolean;
      };
      create_derivative_seed_question_from_derivative_question: {
        Args: { derivative_question_id: number };
        Returns: number;
      };
      create_derivative_seed_question_from_reference_question: {
        Args: { reference_question_id: number };
        Returns: number;
      };
      custom_access_token_hook: { Args: { event: Json }; Returns: Json };
      generate_exam_dates: {
        Args: {
          p_course_level: string;
          p_exam_month: string;
          p_release_days_ahead: number;
          p_start_date?: string;
          p_syllabus_id: number;
        };
        Returns: undefined;
      };
      get_current_user_profile: {
        Args: never;
        Returns: {
          course_level: string | null;
          created_at: string | null;
          current_onboarding_step: Database['public']['Enums']['onboarding_step'] | null;
          email: string;
          final_exam_date: string | null;
          first_name: string | null;
          id: string;
          last_name: string | null;
          last_sign_in_at: string | null;
          onboarded_app: boolean | null;
          onboarded_topic_practice: boolean | null;
          origin: Database['public']['Enums']['user_origin'] | null;
          practice_submitted: boolean;
          profession: Database['public']['Enums']['user_profession'] | null;
          profile_pic: string | null;
          program: Database['categories']['Enums']['program'] | null;
          school_name: string | null;
          streak_goal: number | null;
          syllabus_id: number | null;
          sys_period: unknown;
          updated_at: string | null;
        };
        SetofOptions: {
          from: '*';
          to: 'users';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_current_user_role: {
        Args: never;
        Returns: Database['public']['Enums']['user_role'];
      };
      get_question_items: { Args: { p_question_id: number }; Returns: Json };
      get_reference_question_by_question_id: {
        Args: { question_id: number };
        Returns: {
          course_levels: string[] | null;
          created_at: string | null;
          created_by: string | null;
          human_feedback: string | null;
          id: number;
          llm_feedback: Json | null;
          markscheme_image_bucket: string | null;
          markscheme_image_name: string | null;
          metadata: Json | null;
          parsed_markscheme: Json | null;
          parsed_markscheme_llm_feedback: Json | null;
          question_image_bucket: string | null;
          question_image_name: string | null;
          question_items: Json | null;
          question_labels: string[] | null;
          question_number: number;
          solution_paths: Json | null;
          source_id: string | null;
          source_ref: Json;
          status: Database['public']['Enums']['reference_question_status'] | null;
          status_reason: string | null;
          syllabus_id: number | null;
          sys_period: unknown;
          updated_at: string | null;
          updated_by: string | null;
        }[];
        SetofOptions: {
          from: '*';
          to: 'reference_questions';
          isOneToOne: false;
          isSetofReturn: true;
        };
      };
      get_syllabus_id_for_question: {
        Args: { question_id: number };
        Returns: number;
      };
      get_syllabus_id_for_reference_question: {
        Args: { reference_question_id: number };
        Returns: number;
      };
      get_weekly_marks: {
        Args: { tz: string };
        Returns: {
          day: string;
          total_actual_marks: number;
        }[];
      };
      remove_sensitive_data_recursive: {
        Args: {
          current_type_context?: string;
          input_json: Json;
          removal_config: Json;
        };
        Returns: Json;
      };
      search_questions_with_facets: {
        Args: {
          p_attempted?: boolean;
          p_difficulties?: string[];
          p_limit?: number;
          p_offset?: number;
          p_sort_by?: string;
          p_sort_order?: string;
          p_syllabus_id: number;
          p_topic_level_02_ids?: number[];
          p_topic_match_mode?: Database['public']['Enums']['array_match_mode'];
          p_types?: Database['public']['Enums']['question_type'][];
        };
        Returns: Json;
      };
      transform_to_question_items_public: {
        Args: { question_items_data: Json };
        Returns: Json;
      };
      validate_image_ref: { Args: { image: Json }; Returns: undefined };
    };
    Enums: {
      ai_chat_role_enum: 'user' | 'ai';
      array_match_mode: 'ANY' | 'ALL';
      assessment_types: 'class_test' | 'mock_exam';
      category_level: 'subject' | 'course' | 'topic_area' | 'topic';
      communication_type: 'email' | 'phone';
      exam_course: 'IB Math AA SL' | 'IB Math AA HL' | 'IB Math AI SL' | 'IB Math AI HL';
      onboarding_step:
        | 'story'
        | 'origin'
        | 'course'
        | 'examDate'
        | 'assessment'
        | 'schoolName'
        | 'profession'
        | 'program';
      question_engagement_status: 'EXPOSED' | 'DISCARDED' | 'DRAFT' | 'SUBMITTED' | 'GRADED' | 'COMPLETED';
      question_status:
        | 'DELETED'
        | 'INACTIVE_SEED'
        | 'ACTIVE_SEED'
        | 'DRAFT'
        | 'PUBLISHED'
        | 'GENERALLY_AVAILABLE'
        | 'NEEDS_REVIEW'
        | 'NEEDS_IMAGE'
        | 'IMPOSSIBLE_TO_FIX_BY_AI'
        | 'NEEDS_MARKSCHEME'
        | 'NEEDS_MARKSCHEME_V2'
        | 'INCORRECT_STEMS_AMOUNT'
        | 'PUBLISHED_V2'
        | 'NEEDS_IMAGE_REVIEW'
        | 'INCONSISTENT_POINTS'
        | 'HUMAN_REVIEWED'
        | 'NEEDS_FIX'
        | 'NEEDS_HUMAN_REVIEW'
        | 'NEEDS_AI_REVIEW'
        | 'NEEDS_PRESCREENING'
        | 'SNAPSHOT'
        | 'NEEDS_IMAGE_GENERATION'
        | 'NEEDS_EXPERT_PRESCREENING'
        | 'NEEDS_EXPERT_IMAGE_REVIEW'
        | 'NEEDS_TIE_BREAK';
      question_type: 'FRQ' | 'MCQ';
      reference_question_status:
        | 'DELETED'
        | 'UNFIXABLE'
        | 'DEPRECATED_HUMAN_APPROVED'
        | 'NEEDS_QUESTION_PARSING'
        | 'NEEDS_QUESTION_INTERNAL_REVIEW'
        | 'NEEDS_QUESTION_REVIEW'
        | 'NEEDS_MARKSCHEME_PARSING'
        | 'NEEDS_MARKSCHEME_REVIEW'
        | 'NEEDS_IMAGE_PARSING'
        | 'NEEDS_IMAGE_REVIEW'
        | 'IMAGE_NOT_PARSEABLE'
        | 'NEEDS_TOPIC_TAGGING'
        | 'HUMAN_APPROVED'
        | 'NEEDS_EXPERT_MARKSCHEME_REVIEW'
        | 'NEEDS_EXPERT_IMAGE_REVIEW';
      stem_difficulty_category: 'EASY' | 'MEDIUM' | 'HARD';
      subject_sub_type: 'ALGEBRA' | 'GEOMETRY';
      subject_type: 'MATH';
      subscription_recurrence_interval: 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';
      user_color_scheme: 'light' | 'dark' | 'system';
      user_origin:
        | 'friends_family'
        | 'teacher'
        | 'google_search'
        | 'youtube'
        | 'tiktok'
        | 'reddit'
        | 'instagram'
        | 'facebook'
        | 'linkedin'
        | 'other';
      user_profession: 'student' | 'teacher' | 'tutor';
      user_role: 'STUDENT' | 'CANDIDATE' | 'CONTRIBUTOR' | 'ADMIN';
    };
    CompositeTypes: {
      question_item_ref: {
        item_type: string | null;
        item_id: number | null;
      };
    };
  };
  question_bank: {
    Tables: {
      reference_question_solution_path_topic_points: {
        Row: {
          cdc_path: string | null;
          denominator: number;
          path: Json;
          points: number;
          reference_question_id: number;
          topic_id: number;
        };
        Insert: {
          cdc_path?: string | null;
          denominator: number;
          path: Json;
          points: number;
          reference_question_id: number;
          topic_id: number;
        };
        Update: {
          cdc_path?: string | null;
          denominator?: number;
          path?: Json;
          points?: number;
          reference_question_id?: number;
          topic_id?: number;
        };
        Relationships: [];
      };
      sources: {
        Row: {
          course_levels: string[] | null;
          created_at: string;
          created_by: string | null;
          document_type: Database['question_bank']['Enums']['document_type'];
          extracted_content: Json | null;
          id: string;
          metadata: Json | null;
          name: string;
          parsing_instructions: Json | null;
          processed_content: Json | null;
          raw_source: Json;
          source_ref: Json;
          source_type: Database['question_bank']['Enums']['source_type'];
          status: Database['question_bank']['Enums']['source_status'];
          syllabus_id: number;
          sys_period: unknown;
          tier: number;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          course_levels?: string[] | null;
          created_at?: string;
          created_by?: string | null;
          document_type: Database['question_bank']['Enums']['document_type'];
          extracted_content?: Json | null;
          id?: string;
          metadata?: Json | null;
          name: string;
          parsing_instructions?: Json | null;
          processed_content?: Json | null;
          raw_source: Json;
          source_ref?: Json;
          source_type: Database['question_bank']['Enums']['source_type'];
          status?: Database['question_bank']['Enums']['source_status'];
          syllabus_id: number;
          sys_period?: unknown;
          tier?: number;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          course_levels?: string[] | null;
          created_at?: string;
          created_by?: string | null;
          document_type?: Database['question_bank']['Enums']['document_type'];
          extracted_content?: Json | null;
          id?: string;
          metadata?: Json | null;
          name?: string;
          parsing_instructions?: Json | null;
          processed_content?: Json | null;
          raw_source?: Json;
          source_ref?: Json;
          source_type?: Database['question_bank']['Enums']['source_type'];
          status?: Database['question_bank']['Enums']['source_status'];
          syllabus_id?: number;
          sys_period?: unknown;
          tier?: number;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [];
      };
      sources_history: {
        Row: {
          course_levels: string[] | null;
          created_at: string;
          created_by: string | null;
          document_type: Database['question_bank']['Enums']['document_type'];
          extracted_content: Json | null;
          history_id: string;
          id: string;
          metadata: Json | null;
          name: string;
          parsing_instructions: Json | null;
          processed_content: Json | null;
          raw_source: Json;
          source_ref: Json;
          source_type: Database['question_bank']['Enums']['source_type'];
          status: Database['question_bank']['Enums']['source_status'];
          syllabus_id: number;
          sys_period: unknown;
          tier: number;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          course_levels?: string[] | null;
          created_at: string;
          created_by?: string | null;
          document_type: Database['question_bank']['Enums']['document_type'];
          extracted_content?: Json | null;
          history_id?: string;
          id: string;
          metadata?: Json | null;
          name: string;
          parsing_instructions?: Json | null;
          processed_content?: Json | null;
          raw_source: Json;
          source_ref?: Json;
          source_type: Database['question_bank']['Enums']['source_type'];
          status: Database['question_bank']['Enums']['source_status'];
          syllabus_id: number;
          sys_period: unknown;
          tier: number;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          course_levels?: string[] | null;
          created_at?: string;
          created_by?: string | null;
          document_type?: Database['question_bank']['Enums']['document_type'];
          extracted_content?: Json | null;
          history_id?: string;
          id?: string;
          metadata?: Json | null;
          name?: string;
          parsing_instructions?: Json | null;
          processed_content?: Json | null;
          raw_source?: Json;
          source_ref?: Json;
          source_type?: Database['question_bank']['Enums']['source_type'];
          status?: Database['question_bank']['Enums']['source_status'];
          syllabus_id?: number;
          sys_period?: unknown;
          tier?: number;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [];
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      [_ in never]: never;
    };
    Enums: {
      document_type: 'PDF';
      source_status:
        | 'DRAFT'
        | 'READY_FOR_OCR'
        | 'OCR_IN_PROGRESS'
        | 'OCR_COMPLETED'
        | 'OCR_FAILED'
        | 'READY_FOR_PARSING'
        | 'PARSING_IN_PROGRESS'
        | 'PARSED'
        | 'DELETED'
        | 'FAILED';
      source_type: 'OFFICIAL_PAST_EXAM' | 'TEXT_BOOK' | 'QUESTION_BANK' | 'WEBSITE';
    };
    CompositeTypes: {
      [_ in never]: never;
    };
  };
  review: {
    Tables: {
      actions: {
        Row: {
          created_at: string;
          feedback: Json;
          id: string;
          invalidated: boolean;
          reviewable_item_id: string;
          reviewable_item_snapshot_id: string;
          type: Database['review']['Enums']['action_type'];
          updated_at: string;
          user_id: string | null;
        };
        Insert: {
          created_at?: string;
          feedback: Json;
          id?: string;
          invalidated?: boolean;
          reviewable_item_id: string;
          reviewable_item_snapshot_id: string;
          type: Database['review']['Enums']['action_type'];
          updated_at?: string;
          user_id?: string | null;
        };
        Update: {
          created_at?: string;
          feedback?: Json;
          id?: string;
          invalidated?: boolean;
          reviewable_item_id?: string;
          reviewable_item_snapshot_id?: string;
          type?: Database['review']['Enums']['action_type'];
          updated_at?: string;
          user_id?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'actions_reviewable_item_id_fkey';
            columns: ['reviewable_item_id'];
            isOneToOne: false;
            referencedRelation: 'reviewable_items';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'actions_reviewable_item_snapshot_id_fkey';
            columns: ['reviewable_item_snapshot_id'];
            isOneToOne: false;
            referencedRelation: 'reviewable_item_snapshots';
            referencedColumns: ['id'];
          },
        ];
      };
      content_chats: {
        Row: {
          content_json_path: string;
          created_at: string;
          created_by: string | null;
          llm_chat_id: number;
          reviewable_item_id: string;
          updated_at: string;
          updated_by: string | null;
        };
        Insert: {
          content_json_path: string;
          created_at?: string;
          created_by?: string | null;
          llm_chat_id: number;
          reviewable_item_id: string;
          updated_at?: string;
          updated_by?: string | null;
        };
        Update: {
          content_json_path?: string;
          created_at?: string;
          created_by?: string | null;
          llm_chat_id?: number;
          reviewable_item_id?: string;
          updated_at?: string;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'content_chats_reviewable_item_id_fkey';
            columns: ['reviewable_item_id'];
            isOneToOne: false;
            referencedRelation: 'reviewable_items';
            referencedColumns: ['id'];
          },
        ];
      };
      current_reviews: {
        Row: {
          created_at: string;
          review_session: string;
          reviewable_item_id: string;
          sys_period: unknown;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          review_session?: string;
          reviewable_item_id: string;
          sys_period?: unknown;
          user_id: string;
        };
        Update: {
          created_at?: string;
          review_session?: string;
          reviewable_item_id?: string;
          sys_period?: unknown;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'current_reviews_reviewable_item_id_fkey';
            columns: ['reviewable_item_id'];
            isOneToOne: false;
            referencedRelation: 'reviewable_items';
            referencedColumns: ['id'];
          },
        ];
      };
      current_reviews_history: {
        Row: {
          created_at: string;
          history_id: string;
          review_session: string;
          reviewable_item_id: string;
          sys_period: unknown;
          user_id: string;
        };
        Insert: {
          created_at: string;
          history_id?: string;
          review_session: string;
          reviewable_item_id: string;
          sys_period: unknown;
          user_id: string;
        };
        Update: {
          created_at?: string;
          history_id?: string;
          review_session?: string;
          reviewable_item_id?: string;
          sys_period?: unknown;
          user_id?: string;
        };
        Relationships: [];
      };
      image_chats: {
        Row: {
          created_at: string;
          created_by: string | null;
          image_index: number;
          llm_chat_id: number;
          reviewable_item_id: string;
          updated_at: string;
          updated_by: string | null;
        };
        Insert: {
          created_at?: string;
          created_by?: string | null;
          image_index: number;
          llm_chat_id: number;
          reviewable_item_id: string;
          updated_at?: string;
          updated_by?: string | null;
        };
        Update: {
          created_at?: string;
          created_by?: string | null;
          image_index?: number;
          llm_chat_id?: number;
          reviewable_item_id?: string;
          updated_at?: string;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'image_chats_reviewable_item_id_fkey';
            columns: ['reviewable_item_id'];
            isOneToOne: false;
            referencedRelation: 'reviewable_items';
            referencedColumns: ['id'];
          },
        ];
      };
      reviewable_item_snapshots: {
        Row: {
          created_at: string;
          id: string;
          question_snapshot_id: number | null;
          reference_question_snapshot_id: number | null;
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          id?: string;
          question_snapshot_id?: number | null;
          reference_question_snapshot_id?: number | null;
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          id?: string;
          question_snapshot_id?: number | null;
          reference_question_snapshot_id?: number | null;
          updated_at?: string;
        };
        Relationships: [];
      };
      reviewable_items: {
        Row: {
          created_at: string;
          id: string;
          question_id: number | null;
          reference_question_id: number | null;
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          id?: string;
          question_id?: number | null;
          reference_question_id?: number | null;
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          id?: string;
          question_id?: number | null;
          reference_question_id?: number | null;
          updated_at?: string;
        };
        Relationships: [];
      };
      seeds: {
        Row: {
          approval_expected: boolean;
          created_at: string;
          question_id: number;
          review_id: string | null;
          user_id: string;
        };
        Insert: {
          approval_expected: boolean;
          created_at?: string;
          question_id: number;
          review_id?: string | null;
          user_id: string;
        };
        Update: {
          approval_expected?: boolean;
          created_at?: string;
          question_id?: number;
          review_id?: string | null;
          user_id?: string;
        };
        Relationships: [];
      };
      skips: {
        Row: {
          created_at: string;
          reviewable_item_id: string;
          reviewable_item_snapshot_id: string | null;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          reviewable_item_id: string;
          reviewable_item_snapshot_id?: string | null;
          sys_period?: unknown;
          updated_at?: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          reviewable_item_id?: string;
          reviewable_item_snapshot_id?: string | null;
          sys_period?: unknown;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'skips_reviewable_item_id_fkey';
            columns: ['reviewable_item_id'];
            isOneToOne: false;
            referencedRelation: 'reviewable_items';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'skips_reviewable_item_snapshot_id_fkey';
            columns: ['reviewable_item_snapshot_id'];
            isOneToOne: false;
            referencedRelation: 'reviewable_item_snapshots';
            referencedColumns: ['id'];
          },
        ];
      };
      skips_history: {
        Row: {
          created_at: string;
          history_id: string;
          reviewable_item_id: string;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          created_at: string;
          history_id?: string;
          reviewable_item_id: string;
          sys_period: unknown;
          updated_at: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          history_id?: string;
          reviewable_item_id?: string;
          sys_period?: unknown;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [];
      };
      source_assignments: {
        Row: {
          action_type: Database['review']['Enums']['action_type'];
          created_at: string;
          source_id: string;
          sys_period: unknown;
          updated_at: string;
          updated_by: string | null;
          user_id: string;
        };
        Insert: {
          action_type: Database['review']['Enums']['action_type'];
          created_at?: string;
          source_id: string;
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
          user_id: string;
        };
        Update: {
          action_type?: Database['review']['Enums']['action_type'];
          created_at?: string;
          source_id?: string;
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
          user_id?: string;
        };
        Relationships: [];
      };
      source_assignments_history: {
        Row: {
          action_type: Database['review']['Enums']['action_type'];
          created_at: string;
          history_id: string;
          source_id: string;
          sys_period: unknown;
          updated_at: string;
          updated_by: string | null;
          user_id: string;
        };
        Insert: {
          action_type: Database['review']['Enums']['action_type'];
          created_at: string;
          history_id?: string;
          source_id: string;
          sys_period: unknown;
          updated_at: string;
          updated_by?: string | null;
          user_id: string;
        };
        Update: {
          action_type?: Database['review']['Enums']['action_type'];
          created_at?: string;
          history_id?: string;
          source_id?: string;
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
          user_id?: string;
        };
        Relationships: [];
      };
      user_images: {
        Row: {
          action_id: string | null;
          bucket_name: string | null;
          created_at: string;
          current_review_session: string | null;
          id: string;
          image_name: string | null;
          order: number;
          updated_at: string;
          user_id: string;
        };
        Insert: {
          action_id?: string | null;
          bucket_name?: string | null;
          created_at?: string;
          current_review_session?: string | null;
          id?: string;
          image_name?: string | null;
          order?: number;
          updated_at?: string;
          user_id: string;
        };
        Update: {
          action_id?: string | null;
          bucket_name?: string | null;
          created_at?: string;
          current_review_session?: string | null;
          id?: string;
          image_name?: string | null;
          order?: number;
          updated_at?: string;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'user_images_action_id_fkey';
            columns: ['action_id'];
            isOneToOne: false;
            referencedRelation: 'actions';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'user_images_current_review_session_fkey';
            columns: ['current_review_session'];
            isOneToOne: false;
            referencedRelation: 'current_reviews';
            referencedColumns: ['review_session'];
          },
        ];
      };
      user_review_mode_bindings: {
        Row: {
          created_at: string;
          derivative_expert_image_review: boolean;
          derivative_expert_prescreening: boolean;
          derivative_human_review: boolean;
          derivative_image_review: boolean;
          derivative_prescreening: boolean;
          derivative_tie_break: boolean;
          id: string;
          reference_expert_image_review: boolean;
          reference_expert_markscheme_review: boolean;
          reference_image_review: boolean;
          reference_markscheme_review: boolean;
          reference_question_review: boolean;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
          updated_by: string | null;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          derivative_expert_image_review?: boolean;
          derivative_expert_prescreening?: boolean;
          derivative_human_review?: boolean;
          derivative_image_review?: boolean;
          derivative_prescreening?: boolean;
          derivative_tie_break?: boolean;
          id?: string;
          reference_expert_image_review?: boolean;
          reference_expert_markscheme_review?: boolean;
          reference_image_review?: boolean;
          reference_markscheme_review?: boolean;
          reference_question_review?: boolean;
          syllabus_id: number;
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
          user_id: string;
        };
        Update: {
          created_at?: string;
          derivative_expert_image_review?: boolean;
          derivative_expert_prescreening?: boolean;
          derivative_human_review?: boolean;
          derivative_image_review?: boolean;
          derivative_prescreening?: boolean;
          derivative_tie_break?: boolean;
          id?: string;
          reference_expert_image_review?: boolean;
          reference_expert_markscheme_review?: boolean;
          reference_image_review?: boolean;
          reference_markscheme_review?: boolean;
          reference_question_review?: boolean;
          syllabus_id?: number;
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
          user_id?: string;
        };
        Relationships: [];
      };
      user_review_mode_bindings_history: {
        Row: {
          created_at: string;
          derivative_expert_image_review: boolean;
          derivative_expert_prescreening: boolean;
          derivative_human_review: boolean;
          derivative_image_review: boolean;
          derivative_prescreening: boolean;
          derivative_tie_break: boolean;
          id: string;
          reference_expert_image_review: boolean;
          reference_expert_markscheme_review: boolean;
          reference_image_review: boolean;
          reference_markscheme_review: boolean;
          reference_question_review: boolean;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
          updated_by: string | null;
          user_id: string;
        };
        Insert: {
          created_at: string;
          derivative_expert_image_review: boolean;
          derivative_expert_prescreening: boolean;
          derivative_human_review: boolean;
          derivative_image_review: boolean;
          derivative_prescreening: boolean;
          derivative_tie_break: boolean;
          id: string;
          reference_expert_image_review: boolean;
          reference_expert_markscheme_review: boolean;
          reference_image_review: boolean;
          reference_markscheme_review: boolean;
          reference_question_review: boolean;
          syllabus_id: number;
          sys_period: unknown;
          updated_at: string;
          updated_by?: string | null;
          user_id: string;
        };
        Update: {
          created_at?: string;
          derivative_expert_image_review?: boolean;
          derivative_expert_prescreening?: boolean;
          derivative_human_review?: boolean;
          derivative_image_review?: boolean;
          derivative_prescreening?: boolean;
          derivative_tie_break?: boolean;
          id?: string;
          reference_expert_image_review?: boolean;
          reference_expert_markscheme_review?: boolean;
          reference_image_review?: boolean;
          reference_markscheme_review?: boolean;
          reference_question_review?: boolean;
          syllabus_id?: number;
          sys_period?: unknown;
          updated_at?: string;
          updated_by?: string | null;
          user_id?: string;
        };
        Relationships: [];
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      create_question_review_action: {
        Args: { p_feedback: Json; p_question_id: number };
        Returns: string;
      };
      create_reference_question_review_action: {
        Args: { p_feedback: Json; p_reference_question_id: number };
        Returns: string;
      };
      derivative_images_were_approved_in_last_human_review_feedback: {
        Args: { p_reviewable_item_id: string };
        Returns: boolean;
      };
      feedback_is_empty: { Args: { p_feedback: Json }; Returns: boolean };
      feedback_matches_expected: {
        Args: { actual_feedback: Json; expected_feedback: Json };
        Returns: boolean;
      };
      get_feedback_by_section_and_checklist_item: {
        Args: {
          checklist_item_id: string;
          feedback: Json;
          section_id: string;
          section_type: string;
        };
        Returns: Json;
      };
      get_lower_question_status: {
        Args: {
          current_status: Database['public']['Enums']['question_status'];
          next_status: Database['public']['Enums']['question_status'];
        };
        Returns: string;
      };
      get_lower_reference_question_status: {
        Args: {
          current_status: Database['public']['Enums']['reference_question_status'];
          next_status: Database['public']['Enums']['reference_question_status'];
        };
        Returns: Database['public']['Enums']['reference_question_status'];
      };
      get_next_question_pipeline_status: {
        Args: {
          current_status: Database['public']['Enums']['question_status'];
          question_items: Json;
        };
        Returns: Database['public']['Enums']['question_status'];
      };
      get_next_question_status_from_feedback: {
        Args: {
          checklist_item_id: string;
          checklist_item_value: boolean;
          current_active_status: Database['public']['Enums']['question_status'];
          current_next_status: Database['public']['Enums']['question_status'];
          fixed: boolean;
          question_items: Json;
          section_id: string;
          section_type: string;
        };
        Returns: Database['public']['Enums']['question_status'];
      };
      get_next_reference_question_pipeline_status: {
        Args: {
          current_status: Database['public']['Enums']['reference_question_status'];
          question_items: Json;
        };
        Returns: Database['public']['Enums']['reference_question_status'];
      };
      get_next_reference_question_status_from_feedback: {
        Args: {
          checklist_item_id: string;
          checklist_item_value: boolean;
          current_active_status: Database['public']['Enums']['reference_question_status'];
          current_next_status: Database['public']['Enums']['reference_question_status'];
          fixed: boolean;
          question_items: Json;
          section_id: string;
          section_type: string;
        };
        Returns: Database['public']['Enums']['reference_question_status'];
      };
      get_question_feedback_with_snapshot: {
        Args: { p_question_id: number };
        Returns: {
          action_id: string;
          action_type: Database['review']['Enums']['action_type'];
          created_at: string;
          feedback: Json;
          question_items: Json;
          snapshot_id: number;
          updated_at: string;
          user_email: string;
          user_first_name: string;
          user_id: string;
          user_last_name: string;
        }[];
      };
      get_reference_question_feedback_with_snapshot: {
        Args: { p_reference_question_id: number };
        Returns: {
          action_id: string;
          action_type: Database['review']['Enums']['action_type'];
          created_at: string;
          feedback: Json;
          question_items: Json;
          snapshot_id: number;
          updated_at: string;
          user_email: string;
          user_first_name: string;
          user_id: string;
          user_last_name: string;
        }[];
      };
      question_is_modified_since_another_user: {
        Args: { p_current_user_id: string; p_question_id: number };
        Returns: boolean;
      };
      reference_question_is_modified_since_another_user: {
        Args: { p_current_user_id: string; p_reference_question_id: number };
        Returns: boolean;
      };
      reviewer_can_edit_question: {
        Args: { p_question_id: number; p_user_id: string };
        Returns: boolean;
      };
      update_derivative_question_status_on_skip: {
        Args: { reviewable_item_id: string };
        Returns: undefined;
      };
      update_reference_question_status_on_skip: {
        Args: { reviewable_item_id: string };
        Returns: undefined;
      };
      update_user_review_permissions: {
        Args: { p_syllabus_permissions: Json; p_user_id: string };
        Returns: undefined;
      };
    };
    Enums: {
      action_type:
        | 'image_upload'
        | 'image_ai_review'
        | 'derivative_prescreening'
        | 'derivative_expert_prescreening'
        | 'derivative_image_review'
        | 'derivative_expert_image_review'
        | 'derivative_human_review'
        | 'derivative_tie_break'
        | 'reference_question_review'
        | 'reference_markscheme_review'
        | 'reference_expert_markscheme_review'
        | 'reference_image_review'
        | 'reference_expert_image_review';
    };
    CompositeTypes: {
      [_ in never]: never;
    };
  };
};

type DatabaseWithoutInternals = Omit<Database, '__InternalSupabase'>;

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, 'public'>];

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema['Tables'] & DefaultSchema['Views'])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables'] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Views'])
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables'] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Views'])[TableName] extends {
      Row: infer R;
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema['Tables'] & DefaultSchema['Views'])
    ? (DefaultSchema['Tables'] & DefaultSchema['Views'])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R;
      }
      ? R
      : never
    : never;

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends keyof DefaultSchema['Tables'] | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables']
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables'][TableName] extends {
      Insert: infer I;
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema['Tables']
    ? DefaultSchema['Tables'][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I;
      }
      ? I
      : never
    : never;

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends keyof DefaultSchema['Tables'] | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables']
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables'][TableName] extends {
      Update: infer U;
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema['Tables']
    ? DefaultSchema['Tables'][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U;
      }
      ? U
      : never
    : never;

export type Enums<
  DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema['Enums'] | { schema: keyof DatabaseWithoutInternals },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions['schema']]['Enums']
    : never = never,
> = DefaultSchemaEnumNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions['schema']]['Enums'][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema['Enums']
    ? DefaultSchema['Enums'][DefaultSchemaEnumNameOrOptions]
    : never;

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema['CompositeTypes']
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions['schema']]['CompositeTypes']
    : never = never,
> = PublicCompositeTypeNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions['schema']]['CompositeTypes'][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema['CompositeTypes']
    ? DefaultSchema['CompositeTypes'][PublicCompositeTypeNameOrOptions]
    : never;

export const Constants = {
  analytics: {
    Enums: {},
  },
  billing: {
    Enums: {
      payout_request_status: [
        'DRAFT',
        'WAITING_FOR_APPROVAL',
        'REJECTED',
        'APPROVED',
        'PAYMENT_WAITING_FOR_APPROVAL',
        'PAYMENT_IN_PROGRESS',
        'PAYMENT_SUCCEEDED',
        'PAYMENT_FAILED',
      ],
    },
  },
  categories: {
    Enums: {
      assessment_modes: ['CLASS_TEST', 'MOCK_EXAM', 'FINAL_EXAM'],
      mark_calculation_method: ['ADDITIVE', 'SELECTIVE'],
      pace_boundary_types: ['practice'],
      program: ['AC', 'IBDP', 'HSC', 'AP', 'CAIE_AL', 'PE_GCSE', 'SAT'],
      subject: ['MATH'],
    },
  },
  learn_hub: {
    Enums: {
      language_code: ['en'],
      page_status: ['draft', 'published', 'archived'],
      page_type: ['concept', 'cheat_sheet', 'insights', 'past_papers'],
    },
  },
  learning: {
    Enums: {
      activity_type: ['PRACTICE', 'TEST'],
      challenge_activity_question_attempt_status: ['TODO', 'IN_PROGRESS', 'DONE'],
      challenge_activity_status: ['IN_PROGRESS', 'SUBMITTED', 'GRADED', 'COMPLETED', 'DISCARDED', 'FAILED'],
      practice_activity_status: ['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED', 'DISCARDED', 'FAILED'],
      question_attempt_status: ['PENDING', 'SUBMITTED', 'GRADED', 'FAILED'],
    },
  },
  public: {
    Enums: {
      ai_chat_role_enum: ['user', 'ai'],
      array_match_mode: ['ANY', 'ALL'],
      assessment_types: ['class_test', 'mock_exam'],
      category_level: ['subject', 'course', 'topic_area', 'topic'],
      communication_type: ['email', 'phone'],
      exam_course: ['IB Math AA SL', 'IB Math AA HL', 'IB Math AI SL', 'IB Math AI HL'],
      onboarding_step: ['story', 'origin', 'course', 'examDate', 'assessment', 'schoolName', 'profession', 'program'],
      question_engagement_status: ['EXPOSED', 'DISCARDED', 'DRAFT', 'SUBMITTED', 'GRADED', 'COMPLETED'],
      question_status: [
        'DELETED',
        'INACTIVE_SEED',
        'ACTIVE_SEED',
        'DRAFT',
        'PUBLISHED',
        'GENERALLY_AVAILABLE',
        'NEEDS_REVIEW',
        'NEEDS_IMAGE',
        'IMPOSSIBLE_TO_FIX_BY_AI',
        'NEEDS_MARKSCHEME',
        'NEEDS_MARKSCHEME_V2',
        'INCORRECT_STEMS_AMOUNT',
        'PUBLISHED_V2',
        'NEEDS_IMAGE_REVIEW',
        'INCONSISTENT_POINTS',
        'HUMAN_REVIEWED',
        'NEEDS_FIX',
        'NEEDS_HUMAN_REVIEW',
        'NEEDS_AI_REVIEW',
        'NEEDS_PRESCREENING',
        'SNAPSHOT',
        'NEEDS_IMAGE_GENERATION',
        'NEEDS_EXPERT_PRESCREENING',
        'NEEDS_EXPERT_IMAGE_REVIEW',
        'NEEDS_TIE_BREAK',
      ],
      question_type: ['FRQ', 'MCQ'],
      reference_question_status: [
        'DELETED',
        'UNFIXABLE',
        'DEPRECATED_HUMAN_APPROVED',
        'NEEDS_QUESTION_PARSING',
        'NEEDS_QUESTION_INTERNAL_REVIEW',
        'NEEDS_QUESTION_REVIEW',
        'NEEDS_MARKSCHEME_PARSING',
        'NEEDS_MARKSCHEME_REVIEW',
        'NEEDS_IMAGE_PARSING',
        'NEEDS_IMAGE_REVIEW',
        'IMAGE_NOT_PARSEABLE',
        'NEEDS_TOPIC_TAGGING',
        'HUMAN_APPROVED',
        'NEEDS_EXPERT_MARKSCHEME_REVIEW',
        'NEEDS_EXPERT_IMAGE_REVIEW',
      ],
      stem_difficulty_category: ['EASY', 'MEDIUM', 'HARD'],
      subject_sub_type: ['ALGEBRA', 'GEOMETRY'],
      subject_type: ['MATH'],
      subscription_recurrence_interval: ['DAY', 'WEEK', 'MONTH', 'YEAR'],
      user_color_scheme: ['light', 'dark', 'system'],
      user_origin: [
        'friends_family',
        'teacher',
        'google_search',
        'youtube',
        'tiktok',
        'reddit',
        'instagram',
        'facebook',
        'linkedin',
        'other',
      ],
      user_profession: ['student', 'teacher', 'tutor'],
      user_role: ['STUDENT', 'CANDIDATE', 'CONTRIBUTOR', 'ADMIN'],
    },
  },
  question_bank: {
    Enums: {
      document_type: ['PDF'],
      source_status: [
        'DRAFT',
        'READY_FOR_OCR',
        'OCR_IN_PROGRESS',
        'OCR_COMPLETED',
        'OCR_FAILED',
        'READY_FOR_PARSING',
        'PARSING_IN_PROGRESS',
        'PARSED',
        'DELETED',
        'FAILED',
      ],
      source_type: ['OFFICIAL_PAST_EXAM', 'TEXT_BOOK', 'QUESTION_BANK', 'WEBSITE'],
    },
  },
  review: {
    Enums: {
      action_type: [
        'image_upload',
        'image_ai_review',
        'derivative_prescreening',
        'derivative_expert_prescreening',
        'derivative_image_review',
        'derivative_expert_image_review',
        'derivative_human_review',
        'derivative_tie_break',
        'reference_question_review',
        'reference_markscheme_review',
        'reference_expert_markscheme_review',
        'reference_image_review',
        'reference_expert_image_review',
      ],
    },
  },
} as const;
